import React, {useState,useEffect} from 'react'

import {defaultAccount, IAccount} from './Verifymobile/VerifymobileModel'
import companyLogo from './Avision_Logo.png';
import successlogo from './correct.png';
import failedlogo from './failed.png';
import loadingicon from './load-icon.png';
import {db, storage} from './../firebase';
import './../style.css';
import {
  ref,
  onValue,
  push,
  update,
  remove
} from 'firebase/database';
//import { collection, addDoc, getStorage, ref  } from "firebase/firestore";
import axios from 'axios';
import liff from '@line/liff';
import {Routes, Route, useNavigate} from 'react-router-dom';
import Popup from './../Popup';
import {getStorage, ref as ref_storage, getDownloadURL ,listAll} from "firebase/storage";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import $ from 'jquery';
import { useForm, Controller  } from "react-hook-form";
import Swal from 'sweetalert2'
import {
  InteractionRequiredAuthError,
  InteractionStatus,
} from "@azure/msal-browser";
import { AuthenticatedTemplate, useMsal } from "@azure/msal-react";
import { loginRequest, msalConfig, graphConfig  } from "../authConfig";
import { OTPINSERT_LOG_TYPE } from '../../models/common/common';
import { updateState } from '../../utils/function-utils';
import { ErrorType } from '../../models/common/error';
import { useErrors } from '../../contexts/ErrorContext';



export function Verifymobile() {

  useEffect(() => {
    const getAllData = async () => {
      // await updatadata()
      await checkconsentdata();
      await consentdata();
      await consentdataOther();
      await setfileconfig()
    };
      getAllData();
  //  fetchLiff()
  // checkcustomerlogin();

//  updatadata();
  }, [])

  const [ note, setNote ] = useState("")
  const [data, setData] = useState<IAccount>(defaultAccount)
  //const [hasError, setHasError] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenlincese, setIsOpenlincese] = useState(false);
  const [isOpenotplimit, setIsOpenotplimit] = useState(false);
  const [otperrcode, setotperrcode] = useState<string>();
  const [isOpenotpRemaining, setIsOpenotpRemaining] = useState(false);
  const [messageRemaining, setmessageRemaining] = useState("");
  const [isOpenNotconnectBc, setIsOpenNotconnectBc] = useState(false);
  const [isOpenNotconnectBc2, setIsOpenNotconnectBc2] = useState(false);
  const [isOpenLoading, setIsOpenLoading] = useState(false);
  const [isOpenCheckconsent, setIsOpenCheckconsent] = useState(false);




  const [show, setShow] = useState(false);
  const { setError } = useErrors();

  const [showModalConsentOther, setShowModalConsentOther] = useState(false);
  const [checkConsentBtnClick1, setCheckConsentBtnClick1] = useState(false);

  const [checkConsent1, setCheckConsent1] = useState(false);
  const [checkConsent2, setCheckConsent2] = useState(false);
  const [checkConsent3, setCheckConsent3] = useState(false);
  const [checkConsent4, setCheckConsent4] = useState(false);
  const [checkConsent5, setCheckConsent5] = useState(false);
  const [checkConsent6, setCheckConsent6] = useState(false);

  const [checkConsentRequired2, setCheckConsentRequired2] = useState(true);
  const [checkConsentRequired3, setCheckConsentRequired3] = useState(true);
  const [checkConsentRequired4, setCheckConsentRequired4] = useState(true);
  const [checkConsentRequired5, setCheckConsentRequired5] = useState(true);
  const [checkConsentRequired6, setCheckConsentRequired6] = useState(true);

  const [checkChangeConsent1, setCheckChangeConsent1] = useState<Boolean>();
  const [checkChangeConsent2, setCheckChangeConsent2] = useState<Boolean>();
  const [checkChangeConsent3, setCheckChangeConsent3] = useState<Boolean>();
  const [checkChangeConsent4, setCheckChangeConsent4] = useState<Boolean>();
  const [checkChangeConsent5, setCheckChangeConsent5] = useState<Boolean>();
  const [checkChangeConsent6, setCheckChangeConsent6] = useState<Boolean>();

  const [contentConsent2, setContentConsent2] = useState<any>({});
  const [contentConsent3, setContentConsent3] = useState<any>({});
  const [contentConsent4, setContentConsent4] = useState<any>({});
  const [contentConsent5, setContentConsent5] = useState<any>({});
  const [contentConsent6, setContentConsent6] = useState<any>({});


  const [totalConsentRequired, setTotalConsentRequired] = useState(0);
  const [checkClickConsentRequired, setCheckClickConsentRequired] = useState(0);

  const [checkBtnConfirmBeforeOtp, setCheckBtnConfirmBeforeOtp] = useState(false);
console.log("checkBtnConfirmBeforeOtp",checkBtnConfirmBeforeOtp);
console.log("totalConsentRequired",totalConsentRequired);
console.log("checkClickConsentRequired",checkClickConsentRequired);
console.log("checkChangeConsent2",checkChangeConsent2);
console.log("data.consent2",data.consent2);



  const handleCloseConsent1 = () => setShow(false);
  const handleShowConsent1 = () => setShow(true);
  const handleCloseConsentOther = () => setShowModalConsentOther(false);
  const handleShowConsentOther = () => setShowModalConsentOther(true);

  const updateData = async (fieldsToUpdate: Partial<IAccount>) => {
    const updatedData = {...data, ...fieldsToUpdate}
    await setData(updatedData)
  }

  const navigate = useNavigate();
  const [dataconsent, setdataconsent] = useState('');
  const [dataconsentOther, setdataconsentOther] = useState({});
  const [lincesememberdata, setlincesememberdata] = useState<number>();
const navigateToContacts = () => {
  // 👇️ navigate to /contacts
navigate('/otpVerify');
};

const checkBtnClickCheckConsent =( e : any) => {
  // const theValue = event.currentTarget.value;
  // console.log("the value:", theValue);
  // const theText = event.currentTarget.textContent;
  // e.currentTarget.classList.remove('btn-primary');
  // e.currentTarget.classList.add('btn-info');
  // console.log(e.currentTarget.value);
  if(e.currentTarget.id == 'check_consent1'){
    // alert(e.currentTarget.value)
    if(e.currentTarget.checked == true){
      // console.log($('#btn_confirm_consent1'));
      // $('#btn_confirm_consent1').removeAttr('disabled');
      setCheckConsentBtnClick1(true);
      setCheckChangeConsent1(true);
    }else if(e.currentTarget.checked == false){
      // $('#btn_confirm_consent1').attr('disabled');
      setCheckConsentBtnClick1(false);
      setCheckChangeConsent1(false);
    }
  }
  // var test = $('#card_defult');
  // if(e.currentTarget.innerText == 'Card'){
  //   $('#logo').addClass('d-none');
  //   $('#card_detail').addClass('d-none');
  //   $('#elem_barcode').addClass('d-none');
  //   $('#card_defult').removeClass('d-none');
  //   $('.btnbarcode').removeClass('active');
  //   $('#elem_qrcode').addClass('d-none');
  //   $('.btnqr').removeClass('active');
  //   e.currentTarget.classList.add('active');
  // }else if(e.currentTarget.id == 'card_defult'){
  //   $('#logo').addClass('d-none');
  //   $('#card_detail').removeClass('d-none');
  //   $('#card_defult').addClass('d-none');
  //   $('#elem_barcode').addClass('d-none');
  //   $('.btnbarcode').removeClass('active');
  //   $('#elem_qrcode').addClass('d-none');
  //   $('.btnqr').removeClass('active');
  // }else if(e.currentTarget.id == 'card_detail'){
  //   $('#logo').addClass('d-none');
  //   $('#card_detail').addClass('d-none');
  //   $('#card_defult').removeClass('d-none');
  //   $('#elem_barcode').addClass('d-none');
  //   $('.btnbarcode').removeClass('active');
  //   $('.btnqr').removeClass('active');
  //   $('#elem_qrcode').addClass('d-none');
  // }else if(e.currentTarget.innerText == 'Barcode'){
  //   $('#logo').addClass('d-none');
  //   $('#card_detail').addClass('d-none');
  //   $('#card_defult').addClass('d-none');
  //   $('#elem_barcode').removeClass('d-none');
  //   $('.btncard').removeClass('active');
  //   $('#elem_qrcode').addClass('d-none');
  //   $('.btnqr').removeClass('active');
  //   e.currentTarget.classList.add('active');
  // }else if(e.currentTarget.innerText == 'QRCode'){
  //   $('#logo').addClass('d-none');
  //   $('#card_detail').addClass('d-none');
  //   $('#card_defult').addClass('d-none');
  //   $('#elem_barcode').addClass('d-none');
  //   $('#elem_qrcode').removeClass('d-none');
  //   $('.btncard').removeClass('active');
  //   $('.btnbarcode ').removeClass('active');
  //   e.currentTarget.classList.add('active');
  // }
  // console.log(test);
};


const connectionweb = JSON.parse(""+window.sessionStorage.getItem("connection"));

  const togglePopup = () => {
      setIsOpen(!isOpen);
  }
  const togglePopuplincesemember = () => {
    setIsOpenlincese(!isOpenlincese);
  }
  const togglePopupotplimit = () => {
    setIsOpenotplimit(!isOpenotplimit);
  }
  const togglePopupotpRemaining = () => {
    setIsOpenotpRemaining(!isOpenotpRemaining);
  }
  const togglePopupNotconnectBc = () => {
    setIsOpenNotconnectBc(!isOpenNotconnectBc);
  }
  const togglePopupNotconnectBc2 = () => {
    setIsOpenNotconnectBc2(!isOpenNotconnectBc2);
  }
  const togglePopupLoading = () => {
    setIsOpenLoading(!isOpenLoading);
  }
  const togglePopupCheckconsent = () => {
    setIsOpenCheckconsent(!isOpenCheckconsent);
  }

  function popupotplimit() {
    setIsOpenotplimit(!isOpenotplimit);
  }
  function popupotpRemaining() {
    setIsOpenotpRemaining(!isOpenotpRemaining);
  }
  function popupNotconnectBc() {
    setIsOpenNotconnectBc(!isOpenNotconnectBc);
  }
  function popupNotconnectBc2() {
    setIsOpenNotconnectBc2(!isOpenNotconnectBc2);
  }
  function popupLoading() {
    setIsOpenLoading(!isOpenLoading);
  }
  function popupCheckconsent() {
    setIsOpenCheckconsent(!isOpenCheckconsent);
  }


  function togglePopupsuccess() {
    setIsOpen(!isOpen);
  }
  function popuplincesemember() {
    setIsOpenlincese(!isOpenlincese);
  }

  const [logoImageweb, setLogoImageweb] = useState('');
  async function setfileconfig() {
    const setupwebdefault = JSON.parse(""+window.sessionStorage.getItem("setupwebdefault"));
    const storageRef_logoweb = ref_storage(storage, setupwebdefault.club_logo_path);
    getDownloadURL(storageRef_logoweb).then((url) => {
      // console.log(url);
      setLogoImageweb(url)
    });



  }


    function authenticateUser(user:string, password:string)
    {
        var token = user + ":" + password;
        var hash = btoa(token);
        return "Basic " + hash;
    }
    function checkcluburl(url:any)
    {
        const encoded = encodeURIComponent(url);
        return  encoded;
    }
    const { instance, inProgress, accounts } = useMsal();
      const [apiData, setApiData] = useState(null);
    function authenticateUseroauth2()
    {

    //  console.log(getTokenOath2);

      // const accessTokenRequest:any = {
      //   scopes: "https://api.businesscentral.dynamics.com/.default",
      //   account: accounts[0],
      // };
      // instance
      //   .acquireTokenSilent(accessTokenRequest)
      //   .then((accessTokenResponse) => {
      //     console.log('success',accessTokenResponse)
      //     // Acquire token silent success
      //     // let accessToken = accessTokenResponse.accessToken;
      //     // // Call your API with token
      //     // callApi(accessToken).then((response) => {
      //     //   setApiData(response);
      //     // });
      //   })
      //   .catch((error) => {
      //     // if (error instanceof InteractionRequiredAuthError) {
      //     //   instance.acquireTokenRedirect(accessTokenRequest);
      //     // }
      //     console.log('error',error);
      //   });

      var urloauth2 ="https://login.microsoftonline.com/5c38277a-940a-4379-ab3f-4af498f51929/oauth2/v2.0/token";
      console.log("urlLicense",urloauth2);
      // const client_id="f819b656-bfe2-4c1c-afe4-2936ac1c3988";
      // const scope="https://api.businesscentral.dynamics.com/.default";
      // const grant_type="client_credentials";
      // const client_secret ="jXh8Q~ahPrKrdqLzNkzLn2gq_zt1kY55zEXTWa_Z";
      var myHeaders = new Headers();
        //  myHeaders.append("Authorization", authenticateUser(connectionweb[0].BC_Api_Username,connectionweb[0].BC_Api_Password));

      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
      myHeaders.append('Access-Control-Allow-Origin', '*');
      myHeaders.append("Cookie", "fpc=AjlSAqDRWPJFtAlxaeqHtKHsE2uIAQAAAJElMtsOAAAA");
      myHeaders.append('Access-Control-Allow-Credentials', 'true');
    //  myHeaders.append('Restrict-Access-To-Tenants', 'contoso.onmicrosoft.com,fabrikam.onmicrosoft.com');
    //  myHeaders.append('Access-Control-Allow-Headers', 'access-control-allow-headers,access-control-allow-methods,access-control-allow-origin');




    // const client_id="f819b656-bfe2-4c1c-afe4-2936ac1c3988";
    // const scope="https://api.businesscentral.dynamics.com/.default";
    // const grant_type="client_credentials";
    // const client_secret ="jXh8Q~ahPrKrdqLzNkzLn2gq_zt1kY55zEXTWa_Z";
    var raw = 'client_id=f819b656-bfe2-4c1c-afe4-2936ac1c3988&scope=https://api.businesscentral.dynamics.com.default&grant_type=client_credentials&client_secret=jXh8Q~ahPrKrdqLzNkzLn2gq_zt1kY55zEXTWa_Z';
    var data = JSON.stringify(raw);
    var config:any = {}
    config = {
      method: 'post',
      url: urloauth2,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        "Accept": "application/json",
        'Origin' : '*',
        'Credentials': 'true'
      },
      data : raw
    };

    // var convert_config = JSON.stringify(config);
    // console.log(test_config);
    axios(config)
    .then(function (response) {
        console.log('true');
    })
    .catch(function (error) {
        console.log('errors');
    });

      console.log("raw",raw);

              // fetch(urloauth2, {
              //   method: 'POST',
              //   headers: myHeaders,
              //   body: raw
              // })
              // .then(response => response.json())
              // .then(datares => {
              //   console.log("datares",datares);


              // //  return datares.token_type + datares.access_token;
              //  })
              // .catch(err=> console.log(err))

              var raw = "client_id=f819b656-bfe2-4c1c-afe4-2936ac1c3988&scope=https://api.businesscentral.dynamics.com/.default&grant_type=client_credentials&client_secret=jXh8Q~ahPrKrdqLzNkzLn2gq_zt1kY55zEXTWa_Z";

              var requestOptions:any = {
                method: 'POST',
                headers: myHeaders,
                body: data,
                redirect: 'follow'
              };

              fetch(urloauth2, requestOptions)
                .then(response => response.text())
                .then(result => console.log(result))
                .catch(error => console.log('error', error));

    }


    //  const checkLicense = (e:any) => {
    /*async function checkLicense() {
            var urlLicense =connectionweb[0].BC_Api_Endpoint+connectionweb[0].BC_Api_Otp_Check_Member_License;
            let checkedremain ="";
            var myHeaders = new Headers();

            myHeaders.append("Authorization", authenticateUser(connectionweb[0].BC_Api_Username,connectionweb[0].BC_Api_Password));
            fetch(urlLicense, {
              method: 'GET',
              headers: myHeaders,
              redirect: 'follow'
            })
          .then(response => response.text())
          .then(data => {
            console.log("data",data);

            const licensemember = JSON.parse(data);
              let remaining =licensemember.value[0].lineMemberRemaining ;
              let notilicense =Number(connectionweb[0].Member_License_Remaining_Notification) ;
              setlincesememberdata(remaining);
          if ( remaining == notilicense) {
                //send email
                const str = new Date().toLocaleString('en-US', { timeZone: 'Asia/Jakarta' });
                var urlsendmail =connectionweb[0].Web_Api_Endpoint+"/sendmail";
                const resp =  axios.post(urlsendmail,{
                    "email_from" : connectionweb[0].Admin_Email_Contact_From,
                  //  "email_to" : "bos.yuranan@gmail.com",
                    "email_to" : connectionweb[0].Admin_Email_Contact_To,
                    "subject" : "Member License :  "+connectionweb[0].Customer_Name+" ใกล้ครบจำนวน วันที่ "+str,
                    "message" : "เรียน ผู้ดูแลระบบ   "+connectionweb[0].Customer_Name+"<p>"+connectionweb[0].Web_Database_Project_Id+" ใช้งาน Member License ใกล้ครบจำนวน คงเหลือในระบบจำนวน  : "+connectionweb[0].Member_License_Remaining_Notification
                    +" วันที่ "+str+"</p>"

                },{
                     headers: {
                 "Authorization":authenticateUser(connectionweb[0].Web_Api_Username,connectionweb[0].Web_Api_Password),
                 }
                 })
                 .then(resp=>{
                  console.log(resp);
                 })
                 .catch(err=> console.log(err))
                console.log("suc =20");
             }else if(remaining<=0){
               //show popup licensemember
                 console.log("remaining1",remaining);
                 setlincesememberdata(remaining)

              }else{
              }
          })
          .catch(error => console.log('error', error));

    }*/

const [loading, setLoading] = useState(false);
    const handleClick = (e:any) => {
      if (checkClickConsentRequired!=totalConsentRequired) {
        popupCheckconsent()
        return;
      }
      //AVCDA.011  27/11/2025  Fix OTP repeat send issue
      setCheckBtnConfirmBeforeOtp(false);
      //C-AVCDA.011  27/11/2025  Fix OTP repeat send issue
      popupLoading()
      /*console.log('handleClick',errors);
      console.log("lincesememberdata",typeof lincesememberdata);*/

    //  let checkk=checkLicense();

      //checkLicense
    //  authenticateUseroauth2()
      console.log("authenticateUseroauth2");
      var urlLicense =connectionweb[0].BC_Api_Endpoint+connectionweb[0].BC_Api_Otp_Check_Member_License;
      let checkedremain ="";
      var myHeaders = new Headers();
      myHeaders.append("Authorization", authenticateUser(connectionweb[0].BC_Api_Username,connectionweb[0].BC_Api_Password));
      fetch(urlLicense, {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      })
    .then(response => response.text())
    .then(dataLicense => {
      console.log("data",dataLicense);
        //AVCDA.011  27/11/2025  Fix OTP repeat send issue
        setCheckBtnConfirmBeforeOtp(false);
        //C-AVCDA.011  27/11/2025  Fix OTP repeat send issue
      popupLoading()
      const licensemember = JSON.parse(dataLicense);
        let remaining =licensemember.value[0].lineMemberRemaining ;
        let notilicense =Number(connectionweb[0].Member_License_Remaining_Notification) ;
        setlincesememberdata(remaining);
    if ( remaining == notilicense) {
          //send email
          const str = new Date().toLocaleString('en-US', { timeZone: 'Asia/Jakarta' });
          var urlsendmail =connectionweb[0].Web_Api_Endpoint+"/sendmail";
          const resp =  axios.post(urlsendmail,{
              "email_from" : connectionweb[0].Admin_Email_Contact_From,
            //  "email_to" : "bos.yuranan@gmail.com",
              "email_to" : connectionweb[0].Admin_Email_Contact_To,
              "subject" : "Member License :  "+connectionweb[0].Customer_Name+" ใกล้ครบจำนวน วันที่ "+str,
              "message" : "เรียน ผู้ดูแลระบบ   "+connectionweb[0].Customer_Name+"<p>"+connectionweb[0].Web_Database_Project_Id+" ใช้งาน Member License ใกล้ครบจำนวน คงเหลือในระบบจำนวน  : "+connectionweb[0].Member_License_Remaining_Notification
              +" วันที่ "+str+"</p>"

          },{
               headers: {
           "Authorization":authenticateUser(connectionweb[0].Web_Api_Username,connectionweb[0].Web_Api_Password),
           }
           })
           .then(resp=>{
             // otpQuotaRemaining
             let clubcode = window.sessionStorage.getItem('Club_Code');
             let clubcodeconvert =""+clubcode;
             var urlotpUsage =connectionweb[0].BC_Api_Endpoint+connectionweb[0].BC_Api_Otp_Check_Quota_Insert_Usage;
             var myHeadersotpUsage = new Headers();
             myHeadersotpUsage.append("Authorization", authenticateUser(connectionweb[0].BC_Api_Username,connectionweb[0].BC_Api_Password));
             myHeadersotpUsage.append("Content-Type", "application/json");
             var raw = JSON.stringify({
                 "clubCode": clubcodeconvert,
                 "mobileNo": data.telephone,
                 "firstName": data.username,
                 "lastName": data.lastname,
                 "otpType": OTPINSERT_LOG_TYPE.REGISTER_MEMBER
             });
             console.log("raw",raw);

                     fetch(urlotpUsage, {
                       method: 'POST',
                       headers: myHeadersotpUsage,
                       body: raw,
                       redirect: 'follow'
                     })
                     .then(response => response.text())
                     .then(datares => {
                       console.log("data",datares);
                       const otpUsage = JSON.parse(datares);
                       console.log(otpUsage);
                       if (!otpUsage.SystemId) {
                         console.log("log",otpUsage.error.message);
                         setIsOpenLoading(false);
                         //AVCDA.011  27/11/2025  Fix OTP repeat send issue
                         setCheckBtnConfirmBeforeOtp(true);
                // popupotplimit()
                         updateState<ErrorType>({errorDialogOTP: 
                           {status: true, message: otpUsage.error?.message?.replace(/CorrelationId:.*/, "").trim() || "OTP ไม่เพียงพอ"}
                         }, setError);
                         //C-AVCDA.011  27/11/2025  Fix OTP repeat send issue

                         return ;
                       }
                       console.log(otpUsage.otpRemaining);

                       if (otpUsage.SystemId) {
                                   let notiotp =Number(connectionweb[0].Otp_Remaining_Notification) ;

                                  if (otpUsage.otpRemaining == notiotp) {
                                                 ///send email notiotp connectionweb[0].Admin_Email_Contact_To
                                                 const str = new Date().toLocaleString('en-US', { timeZone: 'Asia/Jakarta' });
                                                 var urlsendmail =connectionweb[0].Web_Api_Endpoint+"/sendmail";
                                                 const resp =  axios.post(urlsendmail,{
                                                     "email_from" : connectionweb[0].Admin_Email_Contact_From,
                                                   //  "email_to" : "bos.yuranan@gmail.com",
                                                     "email_to" : connectionweb[0].Admin_Email_Contact_To,
                                                     "subject" : "OTP Quota : "+connectionweb[0].Customer_Name+" ใกล้ครบจำนวน วันที่ "+str,
                                                     "message" : "เรียน ผู้ดูแลระบบ"+connectionweb[0].Customer_Name+"<p>"+connectionweb[0].Web_Database_Project_Id+" ใช้งาน OTP Quota ใกล้ครบจำนวน คงเหลือในระบบจำนวน : "+connectionweb[0].Otp_Remaining_Notification
                                                     +" วันที่ "+str+"</p>"
                                                 },{
                                                      headers: {
                                                  "Authorization":authenticateUser(connectionweb[0].Web_Api_Username,connectionweb[0].Web_Api_Password),
                                                  }
                                                  })
                                                  .then(resp=>{
                                                   console.log(resp);
                                                   var urlsendotp =connectionweb[0].Otp_Sms_Provider_Endpoint+connectionweb[0].Otp_Sms_Provider_Api_Otp_Send;
                                                 //send otp
                                                 const res =  axios.post(urlsendotp,{"project_key":connectionweb[0].Otp_Sms_Provider_Project_Key,
                                                     "phone":data.telephone}, {
                                                     headers: {
                                                               "Content-Type":"application/json",
                                                               "api_key":connectionweb[0].Otp_Sms_Provider_Api_Key,
                                                               "secret_key":connectionweb[0].Otp_Sms_Provider_Api_Secret,
                                                               },
                                                 }).then(res=>{
                                                   console.log("IsOpenLoading",isOpenLoading);


                                                                 if (res.data.code=="000") {

                                                                   let obj ={token:res.data.result.token,
                                                                     telephone:data.telephone,
                                                                     username:data.username,lastname:data.lastname,ref_code:res.data.result.ref_code,
                                                                     //AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ
                                                                    referalMobileNo: data.referalMobileNo,
                                                                    //C-AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ
                                                                     consent1:checkChangeConsent1,
                                                                     consent2:checkChangeConsent2,
                                                                     consent3:checkChangeConsent3,
                                                                     consent4:checkChangeConsent4,
                                                                     consent5:checkChangeConsent5,
                                                                     consent6:checkChangeConsent6,}
                                                                   window.sessionStorage.setItem("OTPSMS",JSON.stringify(obj));
                                                                 setIsOpenLoading(false);
                                                                 togglePopupsuccess()
                                                                 setTimeout(() => {
                                                                   //AVCDA.011  27/11/2025  Fix OTP repeat send issue
                                                                   setCheckBtnConfirmBeforeOtp(true);
                                                                   //C-AVCDA.011  27/11/2025  Fix OTP repeat send issue
                                                                 navigate('/otpVerify');
                                                                 }, 3000);
                                                                 }else{
                                                                  //AVCDA.011  27/11/2025  Fix OTP repeat send issue
                                                                  setIsOpenLoading(false);
                                                                  setotperrcode("SMS:" + res.data.code+" "+res.data.detail)
                                                                  popupotplimit()
                                                                  setCheckBtnConfirmBeforeOtp(true);
                                                                  //C-AVCDA.011  27/11/2025  Fix OTP repeat send issue
                                                                   console.log("otpnon");
                                                                 }
                                                 }).catch(err=> {console.log(err)
                                                  //AVCDA.011  27/11/2025  Fix OTP repeat send issue
                                                    setIsOpenLoading(false);
                                                    setCheckBtnConfirmBeforeOtp(true);
                                                    updateState<ErrorType>({errorDialogOTP: 
                                                      {status: true, message: "Failed to connect SMS Provider"}
                                                    }, setError);
                                                  })
                                                  //C-AVCDA.011  27/11/2025  Fix OTP repeat send issue
                                                 //send otp
                                                  })
                                                  .catch(err=> {console.log(err)
                                                  //AVCDA.011  27/11/2025  Fix OTP repeat send issue
                                                    setIsOpenLoading(false);
                                                    setCheckBtnConfirmBeforeOtp(true);
                                                    updateState<ErrorType>({errorDialogOTP: 
                                                        {status: true, message: "Failed to connect Email Provider"}
                                                    }, setError);
                                                  })
                                                  //C-AVCDA.011  27/11/2025  Fix OTP repeat send issue
                                                   console.log("notiotp",notiotp);
                                 }else if(otpUsage.otpRemaining <=0){
                                                   setIsOpenLoading(false);
                                                   // popupotplimit()
                                                   setCheckBtnConfirmBeforeOtp(true);
                                                   updateState<ErrorType>({errorDialogOTP: 
                                                     {status: true, message: otpUsage.error?.message?.replace(/CorrelationId:.*/, "").trim() || "OTP ไม่เพียงพอ"}
                                                   }, setError);
                                                   e.preventDefault();
                                                 return ;
                                 }else{
                                   var urlsendotp =connectionweb[0].Otp_Sms_Provider_Endpoint+connectionweb[0].Otp_Sms_Provider_Api_Otp_Send;
                                 //send otp
                                 const res =  axios.post(urlsendotp,{"project_key":connectionweb[0].Otp_Sms_Provider_Project_Key,
                                     "phone":data.telephone}, {
                                     headers: {
                                               "Content-Type":"application/json",
                                               "api_key":connectionweb[0].Otp_Sms_Provider_Api_Key,
                                               "secret_key":connectionweb[0].Otp_Sms_Provider_Api_Secret,
                                               },
                                 }).then(res=>{
                                                 if (res.data.code=="000") {
                                                   let obj ={token:res.data.result.token,
                                                     telephone:data.telephone,
                                                     username:data.username,lastname:data.lastname,ref_code:res.data.result.ref_code,
                                                     //AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ
                                                     referalMobileNo: data.referalMobileNo,
                                                     //C-AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ
                                                     consent1:checkChangeConsent1,
                                                     consent2:checkChangeConsent2,
                                                     consent3:checkChangeConsent3,
                                                     consent4:checkChangeConsent4,
                                                     consent5:checkChangeConsent5,
                                                     consent6:checkChangeConsent6,}
                                                   window.sessionStorage.setItem("OTPSMS",JSON.stringify(obj));
                                                 setIsOpenLoading(false);
                                                 togglePopupsuccess()
                                                 setTimeout(() => {
                                                   //AVCDA.011  27/11/2025  Fix OTP repeat send issue
                                                   setCheckBtnConfirmBeforeOtp(true);
                                                   //C-AVCDA.011  27/11/2025  Fix OTP repeat send issue
                                                 navigate('/otpVerify');
                                                 }, 3000);
                                               }else{
                                                //AVCDA.011  27/11/2025  Fix OTP repeat send issue
                                                setIsOpenLoading(false)
                                                setotperrcode("SMS:" + res.data.code+" "+res.data.detail)
                                                popupotplimit()
                                                setCheckBtnConfirmBeforeOtp(true);
                                                //C-AVCDA.011  27/11/2025  Fix OTP repeat send issue
                                                   console.log("otpnon");
                                                 }
                                 }).catch(err=> {console.log(err)
                                    //AVCDA.011  27/11/2025  Fix OTP repeat send issue
                                    setIsOpenLoading(false)
                                    setCheckBtnConfirmBeforeOtp(true);
                                    updateState<ErrorType>({errorDialogOTP: 
                                      {status: true, message: "Failed to connect SMS Provider"}
                                    }, setError);
                                  })
                                  //C-AVCDA.011  27/11/2025  Fix OTP repeat send issue
                                 //send otp

                                 }
                       }
                       //if (!otpUsage.error) {
                       //  console.log("errrrrr");
                       //  var code ="First Name must have a value in OTP Usage: Entry No.=11. It cannot be zero or empty.";
                       //    setmessageRemaining(code);
                       //  popupotpRemaining()
                       //  e.preventDefault();

                       //    return ;
                       //  }




                     })
                     .catch(error => {
                       setIsOpenLoading(false);
                       //AVCDA.011  27/11/2025  Fix OTP repeat send issue
                       setCheckBtnConfirmBeforeOtp(true);
                       //C-AVCDA.011  27/11/2025  Fix OTP repeat send issue
                       popupNotconnectBc()
                       console.log('error', error)
                     });
                       // otpQuotaRemaining
           })
           .catch(err=> {console.log(err)
           //AVCDA.011  27/11/2025  Fix OTP repeat send issue
            setIsOpenLoading(false);
            setCheckBtnConfirmBeforeOtp(true);
            updateState<ErrorType>({errorDialogOTP: 
                {status: true, message: "Failed to connect Email Provider"}
            }, setError);
            console.log(err)
            })
          //C-AVCDA.011  27/11/2025  Fix OTP repeat send issue
          console.log("suc =20");
       }else if(remaining<=0){
         //show popup licensemember
           console.log("remaining1",remaining);
           setlincesememberdata(remaining)
           setIsOpenLoading(false);
           //AVCDA.011  27/11/2025  Fix OTP repeat send issue
           setCheckBtnConfirmBeforeOtp(true);
           //C-AVCDA.011  27/11/2025  Fix OTP repeat send issue
           popuplincesemember()
             e.preventDefault();
           return ;
        }else{

  /*  if (lincesememberdata <= 0 ) {
      popuplincesemember()
        e.preventDefault();
      return ;
    }else{

      console.log("non checkli",lincesememberdata);
    }*/
//AVCDA.011  27/11/2025  Fix OTP repeat send issue
setCheckBtnConfirmBeforeOtp(false);
//C-AVCDA.011  27/11/2025  Fix OTP repeat send issue
popupLoading()
        // otpQuotaRemaining
        let clubcode = window.sessionStorage.getItem('Club_Code');
        let clubcodeconvert =""+clubcode;
        var urlotpUsage =connectionweb[0].BC_Api_Endpoint+connectionweb[0].BC_Api_Otp_Check_Quota_Insert_Usage;
        var myHeadersotpUsage = new Headers();
        myHeadersotpUsage.append("Authorization", authenticateUser(connectionweb[0].BC_Api_Username,connectionweb[0].BC_Api_Password));
        myHeadersotpUsage.append("Content-Type", "application/json");
        var raw = JSON.stringify({
            "clubCode": clubcodeconvert,
            "mobileNo": data.telephone,
            "firstName": data.username,
            "lastName": data.lastname,
            "otpType": OTPINSERT_LOG_TYPE.REGISTER_MEMBER,
        });
        console.log("raw",raw);

                fetch(urlotpUsage, {
                  method: 'POST',
                  headers: myHeadersotpUsage,
                  body: raw,
                  redirect: 'follow'
                })
                .then(response => response.text())
                .then(datares => {
                  console.log("data",datares);
                  const otpUsage = JSON.parse(datares);
                  console.log(otpUsage);
                  if (!otpUsage.SystemId) {
                    console.log("log",otpUsage.error.message);
                    setIsOpenLoading(false);
                    //AVCDA.011  27/11/2025  Fix OTP repeat send issue
                    // popupotplimit()
                    setCheckBtnConfirmBeforeOtp(true);
                    updateState<ErrorType>({errorDialogOTP: 
                      {status: true, message: otpUsage.error?.message?.replace(/CorrelationId:.*/, "").trim() || "OTP ไม่เพียงพอ"}
                    }, setError);
                    //C-AVCDA.011  27/11/2025  Fix OTP repeat send issue
                    return ;
                  }
                  console.log(otpUsage.otpRemaining);

                  if (otpUsage.SystemId) {
                              let notiotp =Number(connectionweb[0].Otp_Remaining_Notification) ;

                             if (otpUsage.otpRemaining == notiotp) {
                                            ///send email notiotp connectionweb[0].Admin_Email_Contact_To
                                            const str = new Date().toLocaleString('en-US', { timeZone: 'Asia/Jakarta' });
                                            var urlsendmail =connectionweb[0].Web_Api_Endpoint+"/sendmail";
                                            const resp =  axios.post(urlsendmail,{
                                                "email_from" : connectionweb[0].Admin_Email_Contact_From,
                                              //  "email_to" : "bos.yuranan@gmail.com",
                                                "email_to" : connectionweb[0].Admin_Email_Contact_To,
                                                "subject" : "OTP Quota : "+connectionweb[0].Customer_Name+" ใกล้ครบจำนวน วันที่ "+str,
                                                "message" : "เรียน ผู้ดูแลระบบ"+connectionweb[0].Customer_Name+"<p>"+connectionweb[0].Web_Database_Project_Id+" ใช้งาน OTP Quota ใกล้ครบจำนวน คงเหลือในระบบจำนวน : "+connectionweb[0].Otp_Remaining_Notification
                                                +" วันที่ "+str+"</p>"
                                            },{
                                                 headers: {
                                             "Authorization":authenticateUser(connectionweb[0].Web_Api_Username,connectionweb[0].Web_Api_Password),
                                             }
                                             })
                                             .then(resp=>{
                                              console.log(resp);
                                              var urlsendotp =connectionweb[0].Otp_Sms_Provider_Endpoint+connectionweb[0].Otp_Sms_Provider_Api_Otp_Send;
                                            //send otp
                                            const res =  axios.post(urlsendotp,{"project_key":connectionweb[0].Otp_Sms_Provider_Project_Key,
                                                "phone":data.telephone}, {
                                                headers: {
                                                          "Content-Type":"application/json",
                                                          "api_key":connectionweb[0].Otp_Sms_Provider_Api_Key,
                                                          "secret_key":connectionweb[0].Otp_Sms_Provider_Api_Secret,
                                                          },
                                            }).then(res=>{
                                              console.log("IsOpenLoading",isOpenLoading);


                                                            if (res.data.code=="000") {

                                                              let obj ={token:res.data.result.token,
                                                                telephone:data.telephone,
                                                                username:data.username,lastname:data.lastname,ref_code:res.data.result.ref_code,
                                                                //AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ
                                                                referalMobileNo: data.referalMobileNo,
                                                                //C-AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ
                                                                consent1:checkChangeConsent1,
                                                                consent2:checkChangeConsent2,
                                                                consent3:checkChangeConsent3,
                                                                consent4:checkChangeConsent4,
                                                                consent5:checkChangeConsent5,
                                                                consent6:checkChangeConsent6,}
                                                              window.sessionStorage.setItem("OTPSMS",JSON.stringify(obj));
                                                            setIsOpenLoading(false);
                                                            togglePopupsuccess()
                                                            setTimeout(() => {
                                                             //AVCDA.011  27/11/2025  Fix OTP repeat send issue
                                                             setCheckBtnConfirmBeforeOtp(true);
                                                             //C-AVCDA.011  27/11/2025  Fix OTP repeat send issue
                                                            navigate('/otpVerify');
                                                            }, 3000);
                                                            }else{
                                                              console.log("otpnon");
                                                              //AVCDA.011  27/11/2025  Fix OTP repeat send issue
                                                              setIsOpenLoading(false);
                                                              setCheckBtnConfirmBeforeOtp(true);
                                                              console.log("otpnon", res.data.code);
                                                              setotperrcode("SMS:" + res.data.code+" "+res.data.detail);
                                                              popupotplimit()
                                                              //C-AVCDA.011  27/11/2025  Fix OTP repeat send issue
                                                            }
                                            }).catch(err=> {console.log(err)
                                              //AVCDA.011  27/11/2025  Fix OTP repeat send issue
                                              setIsOpenLoading(false);
                                              setCheckBtnConfirmBeforeOtp(true);
                                              updateState<ErrorType>({errorDialogOTP: 
                                                {status: true, message: "Failed to connect SMS Provider"}
                                              }, setError);
                                              e.preventDefault();
                                              return;
                                            })
                                            //C-AVCDA.011  27/11/2025  Fix OTP repeat send issue
                                            //send otp
                                             })
                                             .catch(err=> {console.log(err)
                                              //AVCDA.011  27/11/2025  Fix OTP repeat send issue
                                              setIsOpenLoading(false);
                                              setCheckBtnConfirmBeforeOtp(true);
                                              updateState<ErrorType>({errorDialogOTP: 
                                                  {status: true, message: "Failed to connect Email Provider"}
                                              }, setError);
                                              console.log(err)
                                            })
                                            //C-AVCDA.011  27/11/2025  Fix OTP repeat send issue
                                              console.log("notiotp",notiotp);
                            }else if(otpUsage.otpRemaining <=0){
                                              setIsOpenLoading(false);
                                              //AVCDA.011  27/11/2025  Fix OTP repeat send issue
                                              // popupotplimit()
                                              setCheckBtnConfirmBeforeOtp(true);
                                              updateState<ErrorType>({errorDialogOTP: 
                                                {status: true, message: otpUsage.error?.message?.replace(/CorrelationId:.*/, "").trim() || "OTP ไม่เพียงพอ"}
                                              }, setError);
                                              //C-AVCDA.011  27/11/2025  Fix OTP repeat send issue
                                              e.preventDefault();
                                            return ;
                            }else{
                              var urlsendotp =connectionweb[0].Otp_Sms_Provider_Endpoint+connectionweb[0].Otp_Sms_Provider_Api_Otp_Send;
                            //send otp
                            const res =  axios.post(urlsendotp,{"project_key":connectionweb[0].Otp_Sms_Provider_Project_Key,
                                "phone":data.telephone}, {
                                headers: {
                                          "Content-Type":"application/json",
                                          "api_key":connectionweb[0].Otp_Sms_Provider_Api_Key,
                                          "secret_key":connectionweb[0].Otp_Sms_Provider_Api_Secret,
                                          },
                            }).then(res=>{
                                            if (res.data.code=="000") {
                                              let obj ={token:res.data.result.token,
                                                telephone:data.telephone,
                                                username:data.username,lastname:data.lastname,ref_code:res.data.result.ref_code,
                                                //AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ
                                                referalMobileNo: data.referalMobileNo,
                                                //C-AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ
                                                consent1:checkChangeConsent1,
                                                consent2:checkChangeConsent2,
                                                consent3:checkChangeConsent3,
                                                consent4:checkChangeConsent4,
                                                consent5:checkChangeConsent5,
                                                consent6:checkChangeConsent6,}
                                              window.sessionStorage.setItem("OTPSMS",JSON.stringify(obj));
                                            setIsOpenLoading(false);
                                            togglePopupsuccess()
                                            setTimeout(() => {
                                            //AVCDA.011  27/11/2025  Fix OTP repeat send issue
                                             setCheckBtnConfirmBeforeOtp(true);
                                            //C-AVCDA.011  27/11/2025  Fix OTP repeat send issue
                                            navigate('/otpVerify');
                                            }, 3000);
                                            }else{
                                              console.log("otpnon");
                                              //AVCDA.011  27/11/2025  Fix OTP repeat send issue
                                              setIsOpenLoading(false);
                                              setCheckBtnConfirmBeforeOtp(true);
                                              console.log("otpnon", res.data.code);
                                              setotperrcode("SMS:" + res.data.code+" "+res.data.detail);
                                              popupotplimit();
                                              //C-AVCDA.011  27/11/2025  Fix OTP repeat send issue
                                            }
                            }).catch(err=> {console.log(err)
                               //AVCDA.011  27/11/2025  Fix OTP repeat send issue
                                setIsOpenLoading(false);
                                setCheckBtnConfirmBeforeOtp(true);
                                updateState<ErrorType>({errorDialogOTP: 
                                  {status: true, message: "Failed to connect SMS Provider"}
                                }, setError);
                                e.preventDefault();
                                // return;
                              })
                              //C-AVCDA.011  27/11/2025  Fix OTP repeat send issue
                            //send otp

                            }
                  }
                  //if (!otpUsage.error) {
                  //  console.log("errrrrr");
                  //  var code ="First Name must have a value in OTP Usage: Entry No.=11. It cannot be zero or empty.";
                  //    setmessageRemaining(code);
                  //  popupotpRemaining()
                  //  e.preventDefault();

                  //    return ;
                  //  }




                })
                .catch(error =>
                  {
                      setIsOpenLoading(false);
                      //AVCDA.011  27/11/2025  Fix OTP repeat send issue
                      setCheckBtnConfirmBeforeOtp(true);
                      //C-AVCDA.011  27/11/2025  Fix OTP repeat send issue
                    popupNotconnectBc();
                  console.log('error', error)
                });
                  // otpQuotaRemaining
                }
              })
              .catch(error =>
                {  setIsOpenLoading(false);
                  //AVCDA.011  27/11/2025  Fix OTP repeat send issue
                  setCheckBtnConfirmBeforeOtp(true);
                  //C-AVCDA.011  27/11/2025  Fix OTP repeat send issue
                  popupNotconnectBc();
                  console.log('error', error)
                });
              //checkLicense
              //AVCDA.011  27/11/2025  Fix OTP repeat send issue
              // setIsOpenLoading(false);
              //C-AVCDA.011  27/11/2025  Fix OTP repeat send issue
      }
    const logout = () => {
      liff.logout();
        window.location.reload();
    }
                 const [name, setName] = useState("");
                   const [userLineID, setUserLineID] = useState("");
                   const [pictureUrl, setPictureUrl] = useState("");




                async function checkconsentdata() {
                    const setupwebdefault = window.sessionStorage.getItem("setupwebdefault");
                    let setupdefault= ""+setupwebdefault;
                      const setupdefaultweb = JSON.parse(setupdefault);
                      let arr_consent:any = {};
                      // arr_consent['consent2'] = setupdefaultweb.consent2_require;
                      // arr_consent['consent3'] = setupdefaultweb.consent3_require;
                      // arr_consent['consent4'] = setupdefaultweb.consent4_require;
                      // arr_consent['consent5'] = setupdefaultweb.consent5_require;
                      // arr_consent['consent6'] = setupdefaultweb.consent6_require;
                      // console.log('555',typeof totalConsentRequired);
                      // setTotalConsentRequired(setupdefaultweb.consent1_path != '' ? totalConsentRequired => totalConsentRequired + 1 : totalConsentRequired);
                      // setTotalConsentRequired(setupdefaultweb.consent2_code != '' ? (totalConsentRequired + 1) : totalConsentRequired);
                      // setTotalConsentRequired(setupdefaultweb.consent3_code != '' ? (totalConsentRequired + 1) : totalConsentRequired);
                      // setTotalConsentRequired(setupdefaultweb.consent4_code != '' ? (totalConsentRequired + 1) : totalConsentRequired);
                      // setTotalConsentRequired(setupdefaultweb.consent5_code != '' ? (totalConsentRequired + 1) : totalConsentRequired);
                      // setTotalConsentRequired(setupdefaultweb.consent6_code != '' ? (totalConsentRequired + 1) : totalConsentRequired);

                      // console.log(totalConsentRequired);

                      setCheckConsentRequired2(setupdefaultweb.consent2_require);
                      setCheckConsentRequired3(setupdefaultweb.consent3_require);
                      setCheckConsentRequired4(setupdefaultweb.consent4_require);
                      setCheckConsentRequired5(setupdefaultweb.consent5_require);
                      setCheckConsentRequired6(setupdefaultweb.consent6_require);

                      // console.log(checkConsent1);

                      arr_consent['consent1'] = setupdefaultweb.consent1_path;
                      arr_consent['consent2'] = setupdefaultweb.consent2_code;
                      arr_consent['consent3'] = setupdefaultweb.consent3_code;
                      arr_consent['consent4'] = setupdefaultweb.consent4_code;
                      arr_consent['consent5'] = setupdefaultweb.consent5_code;
                      arr_consent['consent6'] = setupdefaultweb.consent6_code;
                      // console.log('consent', Object.keys(arr_consent).length);
                      setTotalConsentRequired(0);
                      Object.entries(arr_consent).map(([key, value]) => {
                        // console.log(key.split("_"));
                        // const key_split = key.split("_");
                        console.log("value",value);

                        if(!value){
                          $('#'+key).hide();
                          $('#'+key+'_modal').addClass('d-none');
                        }else{

                          setTotalConsentRequired(totalConsentRequired => totalConsentRequired + 1);
                        }

                      })
                      // setTotalConsentRequired(Object.keys(arr_consent).length);
                      // console.log('ffff', totalConsentRequired);
                      // const customer_consent = JSON.parse(""+window.sessionStorage.getItem("Customerdata"));
                      // const arr_consent_member:any = {};
                      // arr_consent_member['inlineCheckboxConsent1'] = setupdefaultweb.consent1_require;
                      // arr_consent_member['inlineCheckboxConsent2'] = setupdefaultweb.consent2_require;
                      // arr_consent_member['inlineCheckboxConsent3'] = setupdefaultweb.consent3_require;
                      // arr_consent_member['inlineCheckboxConsent4'] = setupdefaultweb.consent4_require;
                      // arr_consent_member['inlineCheckboxConsent5'] = setupdefaultweb.consent5_require;
                      // arr_consent_member['inlineCheckboxConsent6'] = setupdefaultweb.consent6_require;

                      // Object.entries(arr_consent_member).map(([key, value]) => {
                      //   // console.log(key);
                      //   // const key_split = key.split("_");
                      //   if(value === true){
                      //     $('#'+key).prop('checked',true);
                      //   }
                      // })
                      // console.log(arr_consent_member);
                    // if(setupdefaultweb.consent2_require == false){
                    //   $('#consent2').addClass("d-none");
                    // }else if(setupdefaultweb.consent3_require == false){
                    //   $('#consent3').addClass("d-none");
                    // }else if(setupdefaultweb.consent4_require == false){
                    //   $('#consent4').addClass("d-none");
                    // }else if(setupdefaultweb.consent5_require == false){
                    //   $('#consent5').addClass("d-none");
                    // }else if(setupdefaultweb.consent6_require == false){
                    //   $('#consent6').addClass("d-none");
                    // }


                }

                async function consentdata() {
                  const storageRefdataconsent = ref_storage(storage, 'config_file/consent/consent1.xml');
                  getDownloadURL(storageRefdataconsent).then((urldataconsent) => {
                    const resdataconsent = axios.get(urldataconsent)
                      .then((resdatadataconsent:any)=> {
                        // console.log(resdatadataconsent.data);
                        setdataconsent(resdatadataconsent.data)
                      })
                      .catch(err=> console.log(err))
                  });


                }



                const clickConsent1 =( e : any) => {
                  setShow(false);
                  setShowModalConsentOther(true);
                }

                async function consentdataOther() {
                  const storageRefdataconsent = ref_storage(storage, 'config_file/consent_web.json');
                  const setupwebdefaultweb = JSON.parse(""+window.sessionStorage.getItem("setupwebdefault"));

                  getDownloadURL(storageRefdataconsent).then((urldataconsent) => {
                    const resdataconsent = axios.get(urldataconsent)
                      .then((resdatadataconsent:any)=> {
                        const consentOther:any = [];
                        Object.values(resdatadataconsent.data).map((val:any) => {
                          //console.log("index",index);

                          // consentOther.push(val);
                          // console.log(val.consent_code);
                        /*  if(val.consent_code == 'CONSENT02'){
                            setContentConsent2(val);
                          }else if(val.consent_code == 'CONSENT03'){
                            setContentConsent3(val);
                            setContentConsent5(val);
                          }else if(val.consent_code == 'CONSENT04'){
                            setContentConsent4(val);
                          }else if(val.consent_code == 'CONSENT05'){
                            setContentConsent5(val);
                          }else if(val.consent_code == 'CONSENT06'){
                            setContentConsent6(val);
                          }*/
                          if (setupwebdefaultweb.consent2_code==val.consent_code) {
                            setContentConsent2(val);
                          }
                          if (setupwebdefaultweb.consent3_code==val.consent_code) {
                            setContentConsent3(val);
                          }
                          if (setupwebdefaultweb.consent4_code==val.consent_code) {
                            setContentConsent4(val);
                          }
                          if (setupwebdefaultweb.consent5_code==val.consent_code) {
                            setContentConsent5(val);
                          }
                          if (setupwebdefaultweb.consent6_code==val.consent_code) {
                            setContentConsent6(val);
                          }
                        });
                        // console.log(consentOther);
                        // setdataconsentOther(consentOther)
                        // console.log(dataconsentOther);
                      })
                      .catch(err=> console.log(err))
                  });


                }
                // css
                let stylesweb = JSON.parse(""+window.sessionStorage.getItem('stylesetup'));

                const styles = {
                  title_style: {
                    "backgroundColor": stylesweb.title_style.background_color,
                    "border": stylesweb.title_style.border,
                    "border-color": stylesweb.title_style.border_color,
                    "border-radius":stylesweb.title_style.border_radius,
                    "color": stylesweb.title_style.font_color,
                    "font-family": stylesweb.title_style.font_name,
                    "font-size": stylesweb.title_style.font_size,
                    "font-weight": stylesweb.title_style.font_weight,
                  },
                  title2_style: {
                    "backgroundColor": stylesweb.title2_style.background_color,
                    "border": stylesweb.title2_style.border,
                    "border-color": stylesweb.title2_style.border_color,
                    "border-radius":stylesweb.title2_style.border_radius,
                    "color": stylesweb.title2_style.font_color,
                    "font-family": stylesweb.title2_style.font_name,
                    "font-size": stylesweb.title2_style.font_size,
                    "font-weight": stylesweb.title2_style.font_weight,
                  },
                  caption_style: {
                    "backgroundColor": stylesweb.caption_style.background_color,
                    "border": stylesweb.caption_style.border,
                    "border-color": stylesweb.caption_style.border_color,
                    "border-radius":stylesweb.caption_style.border_radius,
                    "color": stylesweb.caption_style.font_color,
                    "font-family": stylesweb.caption_style.font_name,
                    "font-size": stylesweb.caption_style.font_size,
                    "font-weight": stylesweb.caption_style.font_weight,
                  },
                  input_data_style: {
                    "backgroundColor": stylesweb.input_data_style.background_color,
                    "border": stylesweb.input_data_style.border,
                    "border-color": stylesweb.input_data_style.border_color,
                    "border-radius":stylesweb.input_data_style.border_radius,
                    "color": stylesweb.input_data_style.font_color,
                    "font-family": stylesweb.input_data_style.font_name,
                    "font-size": stylesweb.input_data_style.font_size,
                    "font-weight": stylesweb.input_data_style.font_weight,
                  },
                  title_consent_style: {
                    "backgroundColor": stylesweb.title_consent_style.background_color,
                    "border": stylesweb.title_consent_style.border,
                    "border-color": stylesweb.title_consent_style.border_color,
                    "border-radius":stylesweb.title_consent_style.border_radius,
                    "color": stylesweb.title_consent_style.font_color,
                    "font-family": stylesweb.title_consent_style.font_name,
                    "font-size": stylesweb.title_consent_style.font_size,
                    "font-weight": stylesweb.title_consent_style.font_weight,
                  },
                  description_consent_style: {
                    "backgroundColor": stylesweb.description_consent_style.background_color,
                    "border": stylesweb.description_consent_style.border,
                    "border-color": stylesweb.description_consent_style.border_color,
                    "border-radius":stylesweb.description_consent_style.border_radius,
                    "color": stylesweb.description_consent_style.font_color,
                    "font-family": stylesweb.description_consent_style.font_name,
                    "font-size": stylesweb.description_consent_style.font_size,
                    "font-weight": stylesweb.description_consent_style.font_weight,
                  },
                  consent_page_style_body: {
                    "backgroundColor": stylesweb.consent_page_style.background_color,
                    "border": stylesweb.consent_page_style.border,
                    "border-color": stylesweb.consent_page_style.border_color,
                    "color": stylesweb.consent_page_style.font_color,
                    "font-family": stylesweb.consent_page_style.font_name,
                    "font-size": stylesweb.consent_page_style.font_size,
                    "font-weight": stylesweb.consent_page_style.font_weight,
                  },
                  consent_page_style_header: {
                    "backgroundColor": stylesweb.consent_page_style.background_color,
                    "border": stylesweb.consent_page_style.border,
                    "border-color": stylesweb.consent_page_style.border_color,
                    "border-top-left-radius": stylesweb.consent_page_style.border_radius,
                    "border-top-right-radius": stylesweb.consent_page_style.border_radius,
                    "color": stylesweb.consent_page_style.font_color,
                    "font-family": stylesweb.consent_page_style.font_name,
                    "font-size": stylesweb.consent_page_style.font_size,
                    "font-weight": stylesweb.consent_page_style.font_weight,
                  },
                  consent_page_style_footer: {
                    "backgroundColor": stylesweb.consent_page_style.background_color,
                    "border": stylesweb.consent_page_style.border,
                    "border-color": stylesweb.consent_page_style.border_color,
                    "border-bottom-left-radius": stylesweb.consent_page_style.border_radius,
                    "border-bottom-right-radius": stylesweb.consent_page_style.border_radius,
                    "color": stylesweb.consent_page_style.font_color,
                    "font-family": stylesweb.consent_page_style.font_name,
                    "font-size": stylesweb.consent_page_style.font_size,
                    "font-weight": stylesweb.consent_page_style.font_weight,
                  },

                  error_message_box_style: {
                    "backgroundColor": stylesweb.error_message_box_style.background_color,
                    "border": stylesweb.error_message_box_style.border,
                    "border-color": stylesweb.error_message_box_style.border_color,
                    "border-radius": stylesweb.error_message_box_style.border_radius,
                    "color": stylesweb.error_message_box_style.font_color,
                    "font-family": stylesweb.error_message_box_style.font_name,
                    "font-size": stylesweb.error_message_box_style.font_size,
                    "font-weight": stylesweb.error_message_box_style.font_weight,
                  },
                  background_Style: {
                    "backgroundColor": stylesweb.background_Style.background_color,
                    "border": stylesweb.background_Style.border,
                    "border-color": stylesweb.background_Style.border_color,
                    "border-radius": stylesweb.background_Style.border_radius,
                    "color": stylesweb.background_Style.font_color,
                    "font-family": stylesweb.background_Style.font_name,
                    "font-size": stylesweb.background_Style.font_size,
                    "font-weight": stylesweb.background_Style.font_weight,
                  },
                  foreground_Style: {
                    "backgroundColor": stylesweb.foreground_Style.background_color,
                    "border": stylesweb.foreground_Style.border,
                    "border-color": stylesweb.foreground_Style.border_color,
                    "border-radius": stylesweb.foreground_Style.border_radius,
                    "color": stylesweb.foreground_Style.font_color,
                    "font-family": stylesweb.foreground_Style.font_name,
                    "font-size": stylesweb.foreground_Style.font_size,
                    "font-weight": stylesweb.foreground_Style.font_weight,
                  },
                  agree_box_consent: {
                    "backgroundColor": stylesweb.agree_box_consent.background_color,
                    "border": stylesweb.agree_box_consent.border,
                    "border-color": stylesweb.agree_box_consent.border_color,
                    "border-radius": stylesweb.agree_box_consent.border_radius,
                    "color": stylesweb.agree_box_consent.font_color,
                    "font-family": stylesweb.agree_box_consent.font_name,
                    "font-size": stylesweb.agree_box_consent.font_size,
                    "font-weight": stylesweb.agree_box_consent.font_weight,
                  },
                  //avnsd
                  confirm_button_style: {
                    "backgroundColor": stylesweb.confirm_button_style.background_color,
                    "border": stylesweb.confirm_button_style.border,
                    "border-color": stylesweb.confirm_button_style.border_color,
                    "border-radius": stylesweb.confirm_button_style.border_radius,
                    "color": stylesweb.confirm_button_style.font_color,
                    "font-family": stylesweb.confirm_button_style.font_name,
                    "font-size": stylesweb.confirm_button_style.font_size,
                    "font-weight": stylesweb.confirm_button_style.font_weight,
                  },
                  //avnsd
                };

// console.log(contentConsent2.consent_code)

        interface IFormInput {
          firstName: string;
          lastName: string;
          //AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ
          referalMobileNo: string,
          //C-AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ
          mobile_phone_number: string;
        }

        const {
          register,
          handleSubmit,
          watch,
          control,
          //AVCDAPNF.004  24/02/2025  Add Code for เอาเบอร์โทรศัพท์มาเช็คกับเบอร์โทรศัพท์ผู้แนะนำ
          getValues,
          //C-AVCDAPNF.004  24/02/2025  Add Code for เอาเบอร์โทรศัพท์มาเช็คกับเบอร์โทรศัพท์ผู้แนะนำ
          trigger,
          formState: { errors }
        } = useForm<IFormInput>();

        const onSubmit = (data:any, e:any) => {
          // alert(JSON.stringify(data));
          console.log(e);
        };
      //AVCDAPNF.001  21/02/2025  Add Code for ให้สามารถติดตามจำนวนการ click consent ให้ครบก่อนแล้วค่อยเปิดให้กดปุ่ม otp verify
      useEffect(() => {
        // ส่วนที่เพิ่ม
        if (totalConsentRequired === checkClickConsentRequired) {
          setCheckBtnConfirmBeforeOtp(true)
        } else {
          setCheckBtnConfirmBeforeOtp(false)
        }
      }, [totalConsentRequired, checkClickConsentRequired])
      //C-AVCDAPNF.001  21/02/2025  Add Code for ให้สามารถติดตามจำนวนการ click consent ให้ครบก่อนแล้วค่อยเปิดให้กดปุ่ม otp verify

      //AVCDAPNF.001  21/02/2025  Add Code for ให้สามารถติดตามจำนวนการ click consent ให้ครบก่อนแล้วค่อยเปิดให้กดปุ่ม otp verify
      const handlePressCheckbox = (
        event: React.PointerEvent<HTMLInputElement>,
        callback?: React.Dispatch<React.SetStateAction<Boolean | undefined>>
      ) => {
        const name = event.currentTarget.name as keyof IAccount
        const isChecked = !data[name]
        if (name === 'consent1') setCheckConsentBtnClick1((prev) => !prev)
        setData((prev) => ({...prev, [name]: isChecked}))
        if (callback) callback((prev) => !prev)
        setCheckClickConsentRequired((prev) => (isChecked ? prev + 1 : prev - 1))
      }
      //C-AVCDAPNF.001  21/02/2025  Add Code for ให้สามารถติดตามจำนวนการ click consent ให้ครบก่อนแล้วค่อยเปิดให้กดปุ่ม otp verify
  	return (


      <div className='card'>
      {/* begin::Form */}

      <div className='row mb-8 imagelogo' style={styles.background_Style}>
      <img src={logoImageweb} alt="metronic"/>
      </div>
      <form className='form d-flex flex-center'   >
        <div className='card-body mw-800px py-20 card-body-editemember' style={styles.foreground_Style}>

          <div 
          //AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
          // className='row mb-8'
          className='row mb-2'
          //C-AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
          >
          <label className='card-label text-center mb-1 col-form-label editemember-header-label' style={styles.title_style}>ลงทะเบียนสมาชิก</label>
          </div>
          <div 
          //AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
          // className='row mb-8'
          className='row mb-2'
          //C-AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
          >
          <label className='card-label   mb-1 col-form-label 'style={styles.title2_style}>กรุณาระบุข้อมูลส่วนตัว</label>
          </div>
          {/* begin::Form row */}
          <div 
          //AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
          // className='row mb-8'
          className='row mb-2'
          //C-AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
          >
            <label className='col-lg-3 col-form-label' style={styles.caption_style} >ชื่อ*</label>
            <div className='col-lg-9'>
              <div className='spinner spinner-sm spinner-primary spinner-right'>
                <input
                  {...register("firstName", {
                    required: true,
                    pattern: /^[A-Za-zก-๙]+$/i,
                    maxLength: 30
                  })}
                  className='form-control form-control-lg form-control-solid'
                  type='text'
                  value={data.username}
                  onChange={(e) => updateData({username: e.target.value})}
                    style={styles.input_data_style}
                />
                {errors?.firstName?.type === "required" && <p className="text-danger">โปรดกรอกชื่อ</p>}
                {errors?.firstName?.type === "pattern" && (
                    <p className="text-danger">ต้องเป็นตัวอักษรเท่านั้น</p>
                )}
                {errors?.firstName?.type === "maxLength" && (
                  <p className="text-danger">นามสกุลมีความยาวเกิน 30 ตัวอักษร</p>
                )}
              </div>
            </div>
          </div>
          {/* end::Form row */}
          {/* begin::Form row */}
          <div 
          //AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
          // className='row mb-8'
          className='row mb-2'
          //C-AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
          >
            <label className='col-lg-3 col-form-label'style={styles.caption_style}>นามสกุล*</label>
            <div className='col-lg-9'>
              <div className='spinner spinner-sm spinner-primary spinner-right'>
                <input
                  {...register("lastName", {
                    required: true,
                    pattern: /^[A-Za-zก-๙]+$/i,
                    maxLength: 30
                  })}
                  className='form-control form-control-lg form-control-solid'
                  type='text'
                  value={data.lastname}
                  onChange={(e) => updateData({lastname: e.target.value})}
                    style={styles.input_data_style}
                />
                {errors?.lastName?.type === "required" && <p className="text-danger">โปรดกรอกนามสกุล</p>}
                {/* {console.log(errors?.firstName?.type)} */}
                {errors?.lastName?.type === "pattern" && (
                  <p className="text-danger">ต้องเป็นตัวอักษรเท่านั้น</p>
                )}
                {errors?.lastName?.type === "maxLength" && (
                  <p className="text-danger">นามสกุลมีความยาวเกิน 30 ตัวอักษร</p>
                )}
              </div>
            </div>
          </div>
          {/* end::Form row */}
          {/* begin::Form row */}
          <div 
          //AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
          // className='row mb-8'
          className='row mb-2'
          //C-AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
          >
            <label className='col-lg-3 col-form-label'style={styles.caption_style}>เบอร์โทรศัพท์*</label>
            <div className='col-lg-9'>
              <div className='spinner spinner-sm spinner-primary spinner-right'>
                <input
                  {...register("mobile_phone_number", {
                    required: true,
                    pattern: /^[0-9]+$/i,
                    minLength: 10,
                    maxLength: 10
                  })}
                  className='form-control form-control-lg form-control-solid'
                  type='number'
                  value={data.telephone}
                  onChange={(e) => updateData({telephone: e.target.value})}
                  style={styles.input_data_style}
                />
                {errors?.mobile_phone_number?.type === "required" && <p className="text-danger">กรุณากรอกเบอร์โทรศัพท์</p>}
                {errors?.mobile_phone_number?.type === "minLength" && (
                  <p className="text-danger">หมายเลขโทรศัพท์ต้องมี 10 หลัก</p>
                )}
                {errors?.mobile_phone_number?.type === "maxLength" && (
                  <p className="text-danger">หมายเลขโทรศัพท์ต้องมี 10 หลัก</p>
                )}
                {errors?.mobile_phone_number?.type === "pattern" && (
                    <p className="text-danger">หมายเลขโทรศัพท์ต้องเป็นตัวเลขเท่านั้น</p>
                  )}
              </div>
            </div>
          </div>
          {/* end::Form row */}
          {/* begin::Form row */}
          {/* //AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ */}
          <div className='row mb-2'>
            <label className='col-lg-3 col-form-label' style={styles.caption_style}>
              เบอร์โทรศัพท์ผู้แนะนำ
            </label>
            <div className='col-lg-9'>
              <div className='spinner spinner-sm spinner-primary spinner-right'>
                <input
                  {...register('referalMobileNo', {
                    pattern: /^[0-9]+$/i,
                    minLength: 10,
                    maxLength: 10,
                    validate: (value) => {
                      const {mobile_phone_number} = getValues()
                      if (value === mobile_phone_number) {
                        return 'เบอร์โทรศัพท์ผู้แนะนำและผู้ลงทะเบียนไม่สามารถซ้ำกันได้'
                      }
                      return true
                    },
                  })}
                  className='form-control form-control-lg form-control-solid'
                  type='number'
                  value={data.referalMobileNo}
                  onChange={(e) => updateData({referalMobileNo: e.target.value})}
                  style={styles.input_data_style}
                />
                {errors?.referalMobileNo?.type === 'minLength' && (
                  <p className='text-danger'>หมายเลขโทรศัพท์ต้องมี 10 หลัก</p>
                )}
                {errors?.referalMobileNo?.type === 'maxLength' && (
                  <p className='text-danger'>หมายเลขโทรศัพท์ต้องมี 10 หลัก</p>
                )}
                {errors?.referalMobileNo?.type === 'pattern' && (
                  <p className='text-danger'>หมายเลขโทรศัพท์ต้องเป็นตัวเลขเท่านั้น</p>
                )}
                {errors?.referalMobileNo?.type === 'validate' && (
                  <p className='text-danger'>{errors.referalMobileNo.message}</p>
                )}
              </div>
            </div>
          </div>
          {/* //C-AVCDAPNF.004  24/02/2025  Add Code for เพิ่ม field ผู้แนะนำ */}
          {/* end::Form row */}
          <div 
          //AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
          // className='row mb-8'
          className='row mb-2'
          //C-AVCDAPNF.007  04/03/2025  Add code for แก้ไข style
          >
          <label className='card-label fw-bolder fs-3 mb-1 col-form-label editemember-header-label' style={styles.title_style}>ข้อกำหนดและเงื่อนไขการเก็บข้อมูลส่วนบุคคล</label>
          </div>
                          {/* begin::Form row */}
                            <div className='row align-items-center mb-3' id='consent1'>
                              <div className='col-lg-9'>
                                <div className='d-flex align-items-center'>
                                <div className='form-check form-check-custom form-check-solid me-5'>
                                  <input
                                    className='form-check-input'
                                    type='checkbox'
                                    //AVCDAPNF.001  21/02/2025  Add Code for ให้สามารถติดตามจำนวนการ click consent ให้ครบก่อนแล้วค่อยเปิดให้กดปุ่ม otp verify
                                    // id='inlineCheckboxConsent1'
                                    // checked={checkChangeConsent1 == true ? true : false}
                                    // onChange={() => updateData({consent1: !data.consent1})}
                                    checked={data.consent1 == true && checkChangeConsent1 == true ? true : false}
                                    name='consent1'
                                    onPointerDown={(e) => handlePressCheckbox(e, setCheckChangeConsent1)}
                                    onChange={() => {}}
                                    //C-AVCDAPNF.001  21/02/2025  Add Code for ให้สามารถติดตามจำนวนการ click consent ให้ครบก่อนแล้วค่อยเปิดให้กดปุ่ม otp verify
                                  />
                                  <label className='form-check-label fw-bold' htmlFor='inlineCheckbox1'
                                  //AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                                  style={styles.input_data_style}
                                  //C-AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                                  >

                                    <span>ยอมรับ</span>

                                    <button type="reset"   onClick={handleShowConsent1} className="span-terms-conditions">นโยบายความเป็นส่วนตัว</button>
                                  </label>

                                </div>
                                </div>
                              </div>
                            </div>
                          {/* begin::Form row */}

                          {/* begin::Form row */}
                          <div className='row align-items-center mb-3' id='consent2'>
                            <div className='col-lg-9'>
                              <div className='d-flex align-items-center'>
                              <div className='form-check form-check-custom form-check-solid me-5'>
                                <input
                                  className='form-check-input'
                                  type='checkbox'
                                  //AVCDAPNF.001  21/02/2025  Add Code for ให้สามารถติดตามจำนวนการ click consent ให้ครบก่อนแล้วค่อยเปิดให้กดปุ่ม otp verify
                                  // id='inlineCheckboxConsent2'
                                  // checked={checkChangeConsent2 == true ? true : false}
                                  // onChange={() => updateData({consent2: !data.consent2})}
                                  checked={data.consent2 == true && checkChangeConsent2 == true ? true : false}
                                  name='consent2'
                                  onPointerDown={(e) => handlePressCheckbox(e, setCheckChangeConsent2)}
                                  onChange={() => {}}
                                  //C-AVCDAPNF.001  21/02/2025  Add Code for ให้สามารถติดตามจำนวนการ click consent ให้ครบก่อนแล้วค่อยเปิดให้กดปุ่ม otp verify
                                />
                                <label className='form-check-label fw-bold' htmlFor='inlineCheckbox1'
                                //AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                                style={styles.input_data_style}
                                //C-AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                                >
                                <span>ยอมรับ</span>

                                <button type="button"   onClick={handleShowConsent1} className="span-terms-conditions">{contentConsent2.consent_title}</button>
                                </label>
                              </div>
                              </div>
                            </div>
                          </div>
                          {/* begin::Form row */}

                          {/* begin::Form row */}
                          <div className='row align-items-center mb-3' id='consent3'>
                            <div className='col-lg-9'>
                              <div className='d-flex align-items-center'>
                              <div className='form-check form-check-custom form-check-solid me-5'>
                                <input
                                  className='form-check-input'
                                  type='checkbox'
                                  //AVCDAPNF.001  21/02/2025  Add Code for ให้สามารถติดตามจำนวนการ click consent ให้ครบก่อนแล้วค่อยเปิดให้กดปุ่ม otp verify
                                  // id='inlineCheckboxConsent3'
                                  // checked={checkChangeConsent3 == true ? true : false}
                                  // onChange={() => updateData({consent3: !data.consent3})}
                                  checked={data.consent3 == true && checkChangeConsent3 == true ? true : false}
                                  name='consent3'
                                  onPointerDown={(e) => handlePressCheckbox(e, setCheckChangeConsent3)}
                                  onChange={() => {}}
                                  //C-AVCDAPNF.001  21/02/2025  Add Code for ให้สามารถติดตามจำนวนการ click consent ให้ครบก่อนแล้วค่อยเปิดให้กดปุ่ม otp verify
                                />
                                <label className='form-check-label fw-bold' htmlFor='inlineCheckbox1'
                                //AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                                style={styles.input_data_style}
                                //C-AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                                >
                                <span>ยอมรับ</span>

                                <button type="button"   onClick={handleShowConsent1} className="span-terms-conditions">{contentConsent3.consent_title}</button>
                                </label>
                              </div>
                              </div>
                            </div>
                          </div>

                          <div className='row align-items-center mb-3' id='consent4' >
                            <div className='col-lg-9'>
                              <div className='d-flex align-items-center'>
                              <div className='form-check form-check-custom form-check-solid me-5'>
                                <input
                                  className='form-check-input'
                                  type='checkbox'
                                  //AVCDAPNF.001  21/02/2025  Add Code for ให้สามารถติดตามจำนวนการ click consent ให้ครบก่อนแล้วค่อยเปิดให้กดปุ่ม otp verify
                                  // id='inlineCheckboxConsent4'
                                  // checked={checkChangeConsent4 == true ? true : false}
                                  // onChange={() => updateData({consent4: !data.consent4})}
                                  checked={data.consent4 == true && checkChangeConsent4 == true ? true : false}
                                  name='consent4'
                                  onPointerDown={(e) => handlePressCheckbox(e, setCheckChangeConsent4)}
                                  onChange={() => {}}
                                  //C-AVCDAPNF.001  21/02/2025  Add Code for ให้สามารถติดตามจำนวนการ click consent ให้ครบก่อนแล้วค่อยเปิดให้กดปุ่ม otp verify
                                />
                                <label className='form-check-label fw-bold' htmlFor='inlineCheckbox1'
                                //AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                                style={styles.input_data_style}
                                //C-AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                                >
                                <span>ยอมรับ</span>

                                <button type="button"   onClick={handleShowConsent1} className="span-terms-conditions">{contentConsent4.consent_title}</button>
                                </label>
                              </div>
                              </div>
                            </div>
                          </div>

                          <div className='row align-items-center mb-3' id='consent5'>
                            <div className='col-lg-9'>
                              <div className='d-flex align-items-center'>
                              <div className='form-check form-check-custom form-check-solid me-5'>
                                <input
                                  className='form-check-input'
                                  type='checkbox'
                                  //AVCDAPNF.001  21/02/2025  Add Code for ให้สามารถติดตามจำนวนการ click consent ให้ครบก่อนแล้วค่อยเปิดให้กดปุ่ม otp verify
                                  // id='inlineCheckboxConsent5'
                                  // checked={checkChangeConsent5 == true ? true : false}
                                  // onChange={() => updateData({consent5: !data.consent5})}
                                  checked={data.consent5 == true && checkChangeConsent5 == true ? true : false}
                                  name='consent5'
                                  onPointerDown={(e) => handlePressCheckbox(e, setCheckChangeConsent5)}
                                  onChange={() => {}}
                                  //C-AVCDAPNF.001  21/02/2025  Add Code for ให้สามารถติดตามจำนวนการ click consent ให้ครบก่อนแล้วค่อยเปิดให้กดปุ่ม otp verify
                                />
                                <label className='form-check-label fw-bold' htmlFor='inlineCheckbox1'
                                //AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                                style={styles.input_data_style}
                                //C-AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                                >
                                <span>ยอมรับ</span>

                                <button type="button"   onClick={handleShowConsent1} className="span-terms-conditions">{contentConsent5.consent_title}</button>
                                </label>
                              </div>
                              </div>
                            </div>
                          </div>

                          <div className='row align-items-center mb-3' id='consent6'>
                            <div className='col-lg-9'>
                              <div className='d-flex align-items-center'>
                              <div className='form-check form-check-custom form-check-solid me-5'>
                                <input
                                  className='form-check-input'
                                  type='checkbox'
                                  //AVCDAPNF.001  21/02/2025  Add Code for ให้สามารถติดตามจำนวนการ click consent ให้ครบก่อนแล้วค่อยเปิดให้กดปุ่ม otp verify
                                  // id='inlineCheckboxConsent6'
                                  // checked={checkChangeConsent6 == true ? true : false}
                                  // onChange={() => updateData({consent6: !data.consent6})}
                                  checked={data.consent6 == true && checkChangeConsent6 == true ? true : false}
                                  name='consent6'
                                  onPointerDown={(e) => handlePressCheckbox(e, setCheckChangeConsent6)}
                                  onChange={() => {}}
                                  //C-AVCDAPNF.001  21/02/2025  Add Code for ให้สามารถติดตามจำนวนการ click consent ให้ครบก่อนแล้วค่อยเปิดให้กดปุ่ม otp verify
                                />
                                <label className='form-check-label fw-bold' htmlFor='inlineCheckbox1'
                                //AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                                style={styles.input_data_style}
                                //C-AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
                                >
                                <span>ยอมรับ</span>

                                <button type="button"   onClick={handleShowConsent1} className="span-terms-conditions">{contentConsent6.consent_title}</button>
                                </label>
                              </div>
                              </div>
                            </div>
                          </div>
                          {/* begin::Form row */}

          {/* begin::Form row */}
          <div className='row'>
            <label className='col-lg-3 col-form-label'></label>
            <div className='col-lg-9'>
                <button type='button' onClick={async (e) => {
                  // console.log(errors);
                  const check_validate = await trigger();
                  if(check_validate === true){
                    handleClick(e)
                  }


                    // console.log(errors?.mobile_phone_number?.type);
                  }
                }
              className='btnmember editemember btn btn-primary  px-6 py-3 me-3' disabled={checkBtnConfirmBeforeOtp == false ? true : false}
              //AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
              style={styles.confirm_button_style}
              //C-AVCDAPNF.007 04/03/2025 Add code for เพิ่ม style
              >
                รับรหัส OTP
              </button>

            </div>
          </div>
          {/* end::Form row */}

        </div>
      </form>
      {/* end::Form */}
          <div>
          <Modal scrollable={true} show={show} onHide={handleCloseConsent1} id="consent1" >
            <Modal.Header closeButton className="bg-secondary1" style={styles.consent_page_style_header}>
              <Modal.Title><h2 style={styles.title_consent_style}>นโยบายความเป็นส่วนตัว</h2></Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-secondary1" style={styles.consent_page_style_body}>
              <div style={styles.description_consent_style} dangerouslySetInnerHTML={{ __html: dataconsent }} />
              <div  className="agree_box" style={styles.agree_box_consent}>
              <Container className="pl-0 pr-0 pb-5 pt-5 mb-5">
                    <Form.Check inline id="check_consent1"
                  //  defaultChecked={checkChangeConsent1 == true ? true : false}
                    //checked={checkChangeConsent1 == true ? true : false}
                      defaultChecked={(data.consent1 == true && checkChangeConsent1==true) ? true : false}
                        onClick={(e) => {
                            // console.log(checkChangeConsent2);
                          /*  if (!checkChangeConsent1) {
                                updateData({consent1: true})
                                setCheckChangeConsent1(true);
                                setCheckConsentBtnClick1(true);
                                setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                            }else{
                               updateData({consent1: true})
                            }*/
                            if(e.currentTarget.checked == true){
                                updateData({consent1: true})
                              setCheckChangeConsent1(true);
                              setCheckConsentBtnClick1(true);
                              setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                            }else{
                                updateData({consent1: false})
                              setCheckChangeConsent1(undefined);
                              setCheckConsentBtnClick1(false);
                              setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired - 1);
                            }

                        }}
                      />
                      <span className="agree_box_consent" style={styles.agree_box_consent}>
                  ข้าพเจ้ายินยอมตามเงื่อนไขของ <strong>นโยบายความเป็นส่วนตัว</strong>
                  </span>
              </Container>
                </div>
            </Modal.Body>

            <Modal.Footer className="flex-column bg-secondary1" style={styles.consent_page_style_footer}>
            {/* <InputGroup className="mb-5 border-0">
              <InputGroup.Checkbox aria-label="Checkbox for following text input" className="border-0 bg-secondary1"/>
              <Form.Control aria-label="Text input with checkbox" value="55555" className="border-left-0"/>
            </InputGroup> */}
              {/*avnsd*/}
              {/*<Button variant="primary" id="btn_confirm_consent1" onClick={(e) => clickConsent1(e)} className="w-100 btn btn-success" disabled={checkConsentBtnClick1 === true ? false : true}>*/}
              <Button variant="primary" id="btn_confirm_consent1" onClick={(e) => clickConsent1(e)} className="w-100 btn btn-success" disabled={checkConsentBtnClick1 === true ? false : true} style={styles.confirm_button_style}>
              {/*avnsd*/}
                ตกลง
              </Button>
            </Modal.Footer>
          </Modal>
            </div>
          {/* onEntered= { function(){
            const setupwebdefault = window.sessionStorage.getItem("setupwebdefault");
            let setupdefault= ""+setupwebdefault;
              const setupdefaultweb = JSON.parse(setupdefault);
              let arr_consent:any = {};
              arr_consent['consent2'] = setupdefaultweb.consent2_require;
              arr_consent['consent3'] = setupdefaultweb.consent3_require;
              arr_consent['consent4'] = setupdefaultweb.consent4_require;
              arr_consent['consent5'] = setupdefaultweb.consent5_require;
              arr_consent['consent6'] = setupdefaultweb.consent6_require;
              Object.entries(arr_consent).map(([key, value]) => {
                // console.log(key.split("_"));
                // const key_split = key.split("_");
                if(value == false){
                  $('#'+key).hide();
                  $('#'+key+'_modal').addClass('d-none');
                }
              })
            }
          } */}
          <Modal
          onEntered=  { function(){
                        const setupwebdefault = window.sessionStorage.getItem("setupwebdefault");
                        let setupdefault= ""+setupwebdefault;
                          const setupdefaultweb = JSON.parse(setupdefault);
                          let arr_consent:any = {};
                          arr_consent['consent2'] = setupdefaultweb.consent2_code;
                          arr_consent['consent3'] = setupdefaultweb.consent3_code;
                          arr_consent['consent4'] = setupdefaultweb.consent4_code;
                          arr_consent['consent5'] = setupdefaultweb.consent5_code;
                          arr_consent['consent6'] = setupdefaultweb.consent6_code;
                          Object.entries(arr_consent).map(([key, value]) => {
                            // console.log(key.split("_"));
                            // const key_split = key.split("_");
                            if(!value){
                              // $('#'+key).hide();
                              $('#'+key+'_modal').hide();
                            }
                          })
                          console.log(totalConsentRequired);
                        }
                      }
          scrollable={true} show={showModalConsentOther} onHide={handleCloseConsentOther} id="consentOther">
            <Modal.Header closeButton className="bg-secondary1" style={styles.consent_page_style_header}>
              {/* <Modal.Title><h2>CONSENT 2</h2></Modal.Title> */}
            </Modal.Header>
            <Modal.Body className="bg-secondary1" style={styles.consent_page_style_body}>
              {/*avnsd*/}
              <h2 style={styles.title_consent_style}>ข้าพเจ้ายินยอมและอนุญาตให้ บริษัท พี แอนด์ เอฟ อินทิเกรท จำกัด ("บริษัทฯ") ในฐานะผู้ควบคุมข้อมูลส่วนบุคคลทำการเก็บ ใช้ และเปิดเผยข้อมูลส่วนบุคคลของข้าพเจ้าภายใต้เงื่อนไขดังต่อไปนี้</h2>
              <br></br>
              {/*avnsd*/}
              <Col id="consent2_modal" >
                <h2 style={styles.title_consent_style}>{contentConsent2.consent_title}</h2>
                <p style={styles.description_consent_style}>{contentConsent2.consent_text}</p>
                <p style={styles.description_consent_style}>{contentConsent2.consent_text2}</p>
                <p style={styles.description_consent_style}>{contentConsent2.consent_text3}</p>
                <p style={styles.description_consent_style}>{contentConsent2.consent_text4}</p>
                <div  className="agree_box" style={styles.agree_box_consent}>
                <Container className="pl-0 pr-0 pb-5 pt-5 mb-5" style={ checkConsentRequired2 == true ? {} : {display:'none'}}>
                    <Form.Check inline id="check_consent2_approve"
                    //checked={checkChangeConsent2 == true ? true : false}
                    defaultChecked={(data.consent2 == true && checkChangeConsent2==true) ? true : false}
                        onClick={(e) => {

                          if(e.currentTarget.checked == true){
                              updateData({consent2: true})
                            setCheckChangeConsent2(true);
                            setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                          }else{
                            //AVCDAPNF.001  20/02/2025  Add Code for แก้ไขตอนมันกด checkbox false มันไปเอา check consent 1 ออก
                              // updateData({consent1: false})
                              updateData({consent2: false})
                            //C-AVCDAPNF.001  20/02/2025  Add Code for แก้ไขตอนมันกด checkbox false มันไปเอา check consent 1 ออก
                            setCheckChangeConsent2(undefined);
                            setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired - 1);
                          }





                        }}
                      />
                      <span className="agree_box_consent" style={styles.agree_box_consent}>
                    ข้าพเจ้ายินยอมตามเงื่อนไขของ <strong>{contentConsent2.consent_title}</strong>
                    </span>
                </Container>
                  </div>
                <div  className="agree_box" style={styles.agree_box_consent}>
                <Container className="pl-0 pr-0 pb-5 pt-5 mb-5" style={ checkConsentRequired2 == true ? {display:'none'} : {}}>
                  <Row>
                    <Col>
                      <Form.Check inline id="check_consent2_approve" name="group2" type="radio"
                      // disabled={checkChangeConsent2 == false ? true : false}
                       //checked={checkChangeConsent2 == true ? true : false}
                      defaultChecked={(data.consent2 == true && checkChangeConsent2==true) ? true : false}
                        onClick={(e) => {

                          if (checkChangeConsent2==false) {
                            updateData({consent2: true})
                            setCheckChangeConsent2(true);
                          }else if(checkChangeConsent2==true){
                            updateData({consent2: true})
                            setCheckChangeConsent2(true);
                          }else{
                            updateData({consent2: true})
                            setCheckChangeConsent2(true);
                            setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                          }


                        }}
                      />
                      <span className="agree_box_consent" style={styles.agree_box_consent}>
                      ข้าพเจ้ายินยอมตามเงื่อนไขของ <strong>{contentConsent2.consent_title}</strong>
                      </span>
                    </Col>
                    <Col className="d-flex justify-content-center">
                      <Form.Check inline id="check_consent2_Non_approve" name="group2" type="radio"
                      //disabled={checkChangeConsent2 == true ? true : false}
                    //  checked={checkChangeConsent2 == false ? true : false}
                      defaultChecked={(data.consent2 == false && checkChangeConsent2==false) ? true : false}
                        onClick={(e) => {

                            if (checkChangeConsent2==true) {
                              updateData({consent2: false})
                              setCheckChangeConsent2(false);
                            }else if(checkChangeConsent2==false){
                              updateData({consent2: false})
                              setCheckChangeConsent2(false);
                            }else{
                              updateData({consent2: false})
                              setCheckChangeConsent2(false);
                              setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                            }


                        }}
                      />
                      <span className="agree_box_consent" style={styles.agree_box_consent}>
                      ไม่ยินยอม
                      </span>
                    </Col>
                  </Row>
                </Container>
                  </div>
              </Col>
              <Col id="consent3_modal" >
              <h2 style={styles.title_consent_style}>{contentConsent3.consent_title}</h2>
                <p style={styles.description_consent_style}>{contentConsent3.consent_text}</p>
                <p style={styles.description_consent_style}>{contentConsent3.consent_text2}</p>
                <p style={styles.description_consent_style}>{contentConsent3.consent_text3}</p>
                <p style={styles.description_consent_style}>{contentConsent3.consent_text4}</p>
                <div  className="agree_box" style={styles.agree_box_consent}>
                <Container className="pl-0 pr-0 pb-5 pt-5 mb-5" style={ checkConsentRequired3 == true ? {} : {display:'none'}}>
                    <Form.Check inline id="check_consent_other"
                    //checked={checkChangeConsent3 == true ? true : false}
                    defaultChecked={(data.consent3 == true && checkChangeConsent3==true) ? true : false}
                        onClick={(e) => {
                            // console.log(checkChangeConsent2);
                            if(e.currentTarget.checked == true){
                                updateData({consent3: true})
                              setCheckChangeConsent3(true);
                              setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                            }else{
                                updateData({consent3: false})
                              setCheckChangeConsent3(undefined);
                              setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired - 1);
                            }

                        }}
                      />
                      <span className="agree_box_consent" style={styles.agree_box_consent}>
                      ข้าพเจ้ายินยอมตามเงื่อนไขของ <strong>{contentConsent3.consent_title}</strong>
                      </span>

                </Container>
                  </div>
                <div  className="agree_box" style={styles.agree_box_consent}>
                <Container className="pl-0 pr-0 pb-5 pt-5 mb-5" style={ checkConsentRequired3 == true ? {display:'none'} : {}}>
                  <Row>
                    <Col>
                      <Form.Check inline id="check_consent_other"   name="group3" type="radio"
                    //  disabled={checkChangeConsent3 == false ? true : false}
                    //  checked={checkChangeConsent3 == true ? true : false}
                    defaultChecked={(data.consent3 == true && checkChangeConsent3==true) ? true : false}
                        onClick={(e) => {
                            // console.log(checkChangeConsent2);
                            if (checkChangeConsent3==false) {
                              updateData({consent3: true})
                              setCheckChangeConsent3(true);
                            }else if(checkChangeConsent3==true){
                              updateData({consent3: true})
                              setCheckChangeConsent3(true);
                            }else{
                              updateData({consent3: true})
                              setCheckChangeConsent3(true);
                              setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                            }

                        }}
                      />
                      <span className="agree_box_consent" style={styles.agree_box_consent}>
                      ข้าพเจ้ายินยอมตามเงื่อนไขของ <strong>{contentConsent3.consent_title}</strong>
                      </span>
                    </Col>
                    <Col className="d-flex justify-content-center">
                      <Form.Check inline id="check_consent_other" name="group3" type="radio"
                      //disabled={checkChangeConsent3 == true ? true : false}
                    //  checked={checkChangeConsent3 == false ? true : false}
                    defaultChecked={(data.consent3 == false && checkChangeConsent3==false) ? true : false}
                        onClick={(e) => {

                          if (checkChangeConsent3==true) {
                            updateData({consent3: false})
                            setCheckChangeConsent3(false);
                          }else if(checkChangeConsent3==false){
                            updateData({consent3: false})
                            setCheckChangeConsent3(false);
                          }else{
                            updateData({consent3: false})
                            setCheckChangeConsent3(false);
                            setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                          }
                        }}
                      />
                      <span className="agree_box_consent" style={styles.agree_box_consent}>
                      ไม่ยินยอม
                      </span>
                    </Col>
                  </Row>
                </Container>
                  </div>
              </Col>
              <Col id="consent4_modal" >
              <h2 style={styles.title_consent_style}>{contentConsent4.consent_title}</h2>
                <p style={styles.description_consent_style}>{contentConsent4.consent_text}</p>
                <p style={styles.description_consent_style}>{contentConsent4.consent_text2}</p>
                <p style={styles.description_consent_style}>{contentConsent4.consent_text3}</p>
                <p style={styles.description_consent_style}>{contentConsent4.consent_text4}</p>
                <div  className="agree_box" style={styles.agree_box_consent}>
                <Container className="pl-0 pr-0 pb-5 pt-5 mb-5" style={ checkConsentRequired4 == true ? {} : {display:'none'}}>
                    <Form.Check inline id="check_consent_other"
                    //checked={checkChangeConsent4 == true ? true : false}
                    defaultChecked={(data.consent4 == true && checkChangeConsent4==true) ? true : false}
                        onClick={(e) => {
                            // console.log(checkChangeConsent2);
                            if(e.currentTarget.checked == true){
                                updateData({consent4: true})
                              setCheckChangeConsent4(true);
                              setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                            }else{
                                updateData({consent4: false})
                              setCheckChangeConsent4(undefined);
                              setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired - 1);
                            }
                        }}
                      />
                      <span className="agree_box_consent" style={styles.agree_box_consent}>
                      ข้าพเจ้ายินยอมตามเงื่อนไขของ <strong>{contentConsent4.consent_title}</strong>
                      </span>

                </Container>
                  </div>
                <div  className="agree_box" style={styles.agree_box_consent}>
                <Container className="pl-0 pr-0 pb-5 pt-5 mb-5" style={ checkConsentRequired4 == true ? {display:'none'} : {}}>
                  <Row>
                    <Col>
                      <Form.Check inline id="check_consent_other" name="group4" type="radio"
                      //disabled={checkChangeConsent4 == false ? true : false}
                      //checked={checkChangeConsent4 == true ? true : false}
                      defaultChecked={(data.consent4 == true && checkChangeConsent4==true) ? true : false}
                        onClick={(e) => {
                            // console.log(checkChangeConsent2);
                            if (checkChangeConsent4==false) {
                                updateData({consent4: true})
                                setCheckChangeConsent4(true);
                            }else if(checkChangeConsent4==true){
                              updateData({consent4: true})
                              setCheckChangeConsent4(true);
                            }else{
                              updateData({consent4: true})
                              setCheckChangeConsent4(true);
                              setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                            }

                        }}
                      />
                      <span className="agree_box_consent" style={styles.agree_box_consent}>
                      ข้าพเจ้ายินยอมตามเงื่อนไขของ <strong>{contentConsent4.consent_title}</strong>
                      </span>
                    </Col>
                    <Col className="d-flex justify-content-center">
                      <Form.Check inline id="check_consent_other" name="group4" type="radio"
                      //disabled={checkChangeConsent4 == true ? true : false}
                      //checked={checkChangeConsent4 == false ? true : false}
                      defaultChecked={(data.consent4 == false && checkChangeConsent4==false) ? true : false}
                        onClick={(e) => {
                            // console.log(checkChangeConsent2);
                            if (checkChangeConsent4==true) {
                              updateData({consent4: false})
                              setCheckChangeConsent4(false);
                            }else if(checkChangeConsent4==false){
                              updateData({consent4: false})
                              setCheckChangeConsent4(false);
                            }else{
                              updateData({consent4: false})
                              setCheckChangeConsent4(false);
                              setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                            }

                        }}
                      />
                      <span className="agree_box_consent" style={styles.agree_box_consent}>
                      ไม่ยินยอม
                      </span>
                    </Col>
                  </Row>
                </Container>
                  </div>
              </Col>
              <Col id="consent5_modal" >
              <h2 style={styles.title_consent_style}>{contentConsent5.consent_title}</h2>
                <p style={styles.description_consent_style}>{contentConsent5.consent_text}</p>
                <p style={styles.description_consent_style}>{contentConsent5.consent_text2}</p>
                <p style={styles.description_consent_style}>{contentConsent5.consent_text3}</p>
                <p style={styles.description_consent_style}>{contentConsent5.consent_text4}</p>
                <div  className="agree_box" style={styles.agree_box_consent}>
                <Container className="pl-0 pr-0 pb-5 pt-5 mb-5" style={ checkConsentRequired5 == true ? {} : {display:'none'}}>
                    <Form.Check inline id="check_consent_other"
                    //checked={checkChangeConsent5 == true ? true : false}
                    defaultChecked={(data.consent5 == true && checkChangeConsent5==true) ? true : false}
                        onClick={(e) => {
                            // console.log(checkChangeConsent2);
                            if(e.currentTarget.checked == true){
                                updateData({consent5: true})
                              setCheckChangeConsent5(true);
                              setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                            }else{
                                updateData({consent5: false})
                              setCheckChangeConsent5(undefined);
                              setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired - 1);
                            }

                        }}
                      />
                      <span className="agree_box_consent" style={styles.agree_box_consent}>
                      ข้าพเจ้ายินยอมตามเงื่อนไขของ <strong>{contentConsent5.consent_title}</strong>
                      </span>

                </Container>
                  </div>
                <div  className="agree_box" style={styles.agree_box_consent}>
                <Container className="pl-0 pr-0 pb-5 pt-5 mb-5" style={ checkConsentRequired5 == true ? {display:'none'} : {}}>
                  <Row>
                    <Col>
                      <Form.Check inline id="check_consent_other" name="group5" type="radio"
                    //  disabled={checkChangeConsent5 == false ? true : false}
                    //  checked={checkChangeConsent5 == true ? true : false}
                    defaultChecked={(data.consent5 == true && checkChangeConsent5==true) ? true : false}
                        onClick={(e) => {
                          if (checkChangeConsent5==false) {
                            updateData({consent5: true})
                            setCheckChangeConsent5(true);
                          }else if(checkChangeConsent5==true){
                            updateData({consent5: true})
                            setCheckChangeConsent5(true);
                          }else{
                            updateData({consent5: true})
                            setCheckChangeConsent5(true);
                            setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                          }
                        }}
                      />
                      <span className="agree_box_consent" style={styles.agree_box_consent}>
                      ข้าพเจ้ายินยอมตามเงื่อนไขของ <strong>{contentConsent5.consent_title}</strong>
                      </span>
                    </Col>
                    <Col className="d-flex justify-content-center">
                      <Form.Check inline id="check_consent_other" name="group5" type="radio"
                    //  disabled={checkChangeConsent5 == true ? true : false}
                      //checked={checkChangeConsent5 == false ? true : false}
                      defaultChecked={(data.consent5 == false && checkChangeConsent5==false) ? true : false}
                        onClick={(e) => {
                            // console.log(checkChangeConsent2);
                            if (checkChangeConsent5==true) {
                              updateData({consent5: false})
                              setCheckChangeConsent5(false);
                            }else if(checkChangeConsent5==false){
                              updateData({consent5: false})
                              setCheckChangeConsent5(false);
                            }else{
                              updateData({consent5: false})
                              setCheckChangeConsent5(false);
                              setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                            }

                        }}
                      />
                      <span className="agree_box_consent" style={styles.agree_box_consent}>
                      ไม่ยินยอม
                      </span>
                    </Col>
                  </Row>
                </Container>
                  </div>
              </Col>
              <Col id="consent6_modal" >
              <h2 style={styles.title_consent_style}>{contentConsent6.consent_title}</h2>
                <p style={styles.description_consent_style}>{contentConsent6.consent_text}</p>
                <p style={styles.description_consent_style}>{contentConsent6.consent_text2}</p>
                <p style={styles.description_consent_style}>{contentConsent6.consent_text3}</p>
                <p style={styles.description_consent_style}>{contentConsent6.consent_text4}</p>
                <div  className="agree_box" style={styles.agree_box_consent}>
                <Container className="pl-0 pr-0 pb-5 pt-5 mb-5" style={ checkConsentRequired6 == true ? {} : {display:'none'}}>
                    <Form.Check inline id="check_consent_other"
                    //checked={checkChangeConsent6 == true ? true : false}
                    defaultChecked={(data.consent6 == true && checkChangeConsent6==true) ? true : false}
                        onClick={(e) => {
                            // console.log(checkChangeConsent2);
                            if(e.currentTarget.checked == true){
                                updateData({consent6: true})
                              setCheckChangeConsent6(true);
                              setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                            }else{
                                updateData({consent6: false})
                              setCheckChangeConsent6(undefined);
                              setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired - 1);
                            }

                        }}
                      />
                      <span className="agree_box_consent" style={styles.agree_box_consent}>
                      ข้าพเจ้ายินยอมตามเงื่อนไขของ <strong>{contentConsent6.consent_title}</strong>
                      </span>

                </Container>
                  </div>
                <div  className="agree_box" style={styles.agree_box_consent}>
                <Container className="pl-0 pr-0 pb-5 pt-5 mb-5" style={ checkConsentRequired6 == true ? {display:'none'} : {}}>
                  <Row>
                    <Col>
                      <Form.Check inline id="check_consent_other" name="group6" type="radio"
                    //  disabled={checkChangeConsent6 == false ? true : false}
                    //  checked={checkChangeConsent6 == true ? true : false}
                    defaultChecked={(data.consent6 == true && checkChangeConsent6==true) ? true : false}
                        onClick={(e) => {
                            // console.log(checkChangeConsent2);
                            if (checkChangeConsent6==false) {
                              updateData({consent6: true})
                              setCheckChangeConsent6(true);
                            }else if(checkChangeConsent6==true){
                              updateData({consent6: true})
                              setCheckChangeConsent6(true);
                            }else{
                              updateData({consent6: true})
                              setCheckChangeConsent6(true);
                              setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                            }

                        }}
                      />
                      <span className="agree_box_consent" style={styles.agree_box_consent}>
                      ข้าพเจ้ายินยอมตามเงื่อนไขของ <strong>{contentConsent6.consent_title}</strong>
                      </span>
                    </Col>
                    <Col className="d-flex justify-content-center">
                      <Form.Check inline id="check_consent_other" name="group6" type="radio"
                    //  disabled={checkChangeConsent6 == true ? true : false}
                    //  checked={checkChangeConsent6 == false ? true : false}
                    defaultChecked={(data.consent6 == false && checkChangeConsent6==false) ? true : false}
                        onClick={(e) => {
                            // console.log(checkChangeConsent2);
                            if (checkChangeConsent6==true) {
                              updateData({consent6: false})
                              setCheckChangeConsent6(false);
                            }else if(checkChangeConsent6==false){
                              updateData({consent6: false})
                              setCheckChangeConsent6(false);
                            }else{
                              updateData({consent6: false})
                              setCheckChangeConsent6(false);
                              setCheckClickConsentRequired(checkClickConsentRequired => checkClickConsentRequired + 1);
                            }

                        }}
                      />
                      <span className="agree_box_consent" style={styles.agree_box_consent}>
                      ไม่ยินยอม
                      </span>
                    </Col>
                  </Row>
                </Container>
                  </div>
              </Col>
              {/*avnsd*/}
              <h2 style={styles.title_consent_style}>ข้าพเจ้าได้อ่านข้อความข้างต้นและเข้าใจโดยตลอดแล้ว</h2>
              {/*avnsd*/}
            </Modal.Body>


            <Modal.Footer className="flex-column bg-secondary1" style={styles.consent_page_style_footer}>
            {/* <InputGroup className="mb-5 border-0">
              <InputGroup.Checkbox aria-label="Checkbox for following text input" className="border-0 bg-secondary1"/>
              <Form.Control aria-label="Text input with checkbox" value="55555" className="border-left-0"/>
            </InputGroup> */}


              <Button variant="primary" id="btn_confirm_consent_other"
                onClick={() =>
                  [
                    handleCloseConsentOther(),
                    setCheckBtnConfirmBeforeOtp(true)
                  ]
                }
              className="w-100 btn btn-success" disabled={totalConsentRequired != checkClickConsentRequired ? true : false} style={styles.confirm_button_style}>
                ตกลง
              </Button>
            </Modal.Footer>
          </Modal>
          {isOpen && <Popup
            content={<>
                <div className="box" style={styles.error_message_box_style}>
              <img src={successlogo} alt="success" className="img-correct"/>

              <p>ระบบได้ทำการส่ง OTP เรียบร้อย</p>
              <p>กรุณาตรวจสอบ SMS</p>

          </div>
            </>}
            handleClose={togglePopup}
          />}
          {isOpenlincese && <Popup
            content={<>
                <div className="box" style={styles.error_message_box_style}>
              <img src={failedlogo} alt="failedlogo" className="img-correct"/>

              <p>ระบบไม่สามารถใช้งานได้ในขณะนี้
                  กรุณาทำรายการภายหลังอีกครั้ง
                  ขออภัยในความไม่สะดวก
                  Error Code : 001
                  </p>


          </div>
            </>}
            handleClose={togglePopuplincesemember}
          />}
          {isOpenotplimit && <Popup
            content={<>
                <div className="box" style={styles.error_message_box_style}>
              <img src={failedlogo} alt="failedlogo" className="img-correct"/>
              <p>ระบบไม่สามารถใช้งานได้ในขณะนี้
                  กรุณาทำรายการภายหลังอีกครั้ง
                  ขออภัยในความไม่สะดวก
                  {/* //AVCDAPNF.001  20/02/2025  Add Code for แจ้ง Error code จาก backend มาแสดง */}
                  {/* Error Code : 002 */}
                  Error Code : {otperrcode}
                  {/* //C-AVCDAPNF.001  20/02/2025  Add Code for แจ้ง Error code จาก backend มาแสดง */}
                   </p>
              </div>
            </>}
            handleClose={togglePopupotplimit}
          />}
          {isOpenotpRemaining && <Popup
            content={<>
                <div className="box" style={styles.error_message_box_style}>
              <img src={failedlogo} alt="failedlogo" className="img-correct"/>
              <p>
              {messageRemaining}</p>

          </div>
            </>}
            handleClose={togglePopupotpRemaining}
          />}
          {isOpenNotconnectBc && <Popup
            content={<>
                <div className="box" style={styles.error_message_box_style}>
              <img src={failedlogo} alt="failedlogo" className="img-correct"/>
              <p>ระบบไม่สามารถใช้งานได้ในขณะนี้
                  กรุณาทำรายการภายหลังอีกครั้ง
                  ขออภัยในความไม่สะดวก
                  Error Code : 004
                  </p>

          </div>
            </>}
            handleClose={togglePopupNotconnectBc}
          />}
          {isOpenNotconnectBc2 && <Popup
            content={<>
                <div className="box" style={styles.error_message_box_style}>
              <img src={failedlogo} alt="failedlogo" className="img-correct"/>
              <p>ระบบไม่สามารถใช้งานได้ในขณะนี้
                  กรุณาทำรายการภายหลังอีกครั้ง
                  ขออภัยในความไม่สะดวก
                  Error Code : 003
                  </p>

          </div>
            </>}
            handleClose={togglePopupNotconnectBc2}
          />}
          {isOpenCheckconsent && <Popup
            content={<>
                <div className="box" style={styles.error_message_box_style}>
              <img src={failedlogo} alt="failedlogo" className="img-correct"/>
              {/*avnsd*/}
              {/*<p>กรุณาใส่ข้อมูล Consent </p>*/}
              <p>กรุณาระบุข้อกำหนดและเงื่อนไขการเก็บข้อมูลส่วนบุคคล</p>
              {/*avnsd*/}

          </div>
            </>}
            handleClose={togglePopupCheckconsent}
          />}
          {isOpenLoading && <Popup
            content={<>
                <div className="box" style={styles.error_message_box_style}>
                <h2>Loading....</h2>
                <img src={loadingicon} alt="success" className="img-correct loading-icon"/>
          </div>
            </>}
          />}

          </div>




  	)
}
